import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { HistoricoProdutoComponent } from '../../historico-produto/historico-produto.component';
import { KendoPopupUtils } from '../../lib/KendoPopupUtils';
import { ConstantsService } from '../../fidelidade/ConstantsService';
import { RotaGuardClient } from '../../guards/auth-loja.guard';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { NotificationService } from '../../services/notification.service';
import { ProdutosV2FacadeService } from '../produtos-v2.facade';
import {
  ChoiceGroupVM,
  ChoiceOptionVM,
  LibraryGroupVM,
  PizzaAdditionalVM,
  ProductFiscalCestOptionVM,
  ProductEditorGroupDraftModeV2,
  ProductFiscalNcmOptionVM,
  ProductEditorSurfaceV2,
  ProductEditorVM,
  ProductPriceTableRowVM,
  ProductTypeV2
} from '../produtos-v2.models';
import { TelaEditorAdicionalV2Component } from '../tela-editor-adicional-v2/tela-editor-adicional-v2.component';
import { TabelaPrecosService } from '../tabela-precos.service';
import { ComissionamentoService } from '../../services/comissionamento.service';
import { CatalogosService } from '../../superadmin/services/catalogos.service';
import { ConfirmacaoV2 } from '../confirmacao-v2';

type ProductEditorOptionModeV2 = 'review' | 'activation' | 'batch-price';
type ProductEditorOptionSortV2 = 'name-asc' | 'price-asc' | 'price-desc';
type BatchPriceAdjustMode = 'fixed' | 'increment' | 'percent';
type BatchPriceAdjustDirection = 'increase' | 'decrease';
type ProductEditorTabV2 = 'info' | 'pricing' | 'photos' | 'adicionais' | 'availability' | 'fiscal';

type CreationErrorsV2 = { name?: string; categoryId?: string; basePrice?: string };

@Component({
  selector: 'app-tela-editor-produto-v2',
  templateUrl: './tela-editor-produto-v2.component.html',
  styleUrls: ['./tela-editor-produto-v2.component.scss']
})
export class TelaEditorProdutoV2Component implements OnInit, OnChanges, OnDestroy {
  @ViewChild(TelaEditorAdicionalV2Component) adicionalEditorComponent?: TelaEditorAdicionalV2Component;
  readonly mobileDenseGroupThreshold = 10;
  readonly quantityModeRolloutEnabled = true;
  @Input() embedded = false;
  @Input() productId: number | null = null;
  @Input() newProductType: ProductTypeV2 | null = null;
  /** Categoria pré-selecionada ao criar (vinda do filtro do catálogo). */
  @Input() initialCategoryId: number | null = null;
  /** Incrementado pelo catálogo para reabrir o formulário de criação após "Salvar e novo". */
  @Input() creationSeed = 0;
  @Input() startWithPreview = false;
  @Input() startWithLibrary = false;
  @Input() pizzaTemplateId: number | null = null;
  @Input() surfaceMode: ProductEditorSurfaceV2 = 'overview';
  @Input() focusGroupId: number | string | null = null;
  @Input() groupDraftMode: ProductEditorGroupDraftModeV2 | null = null;
  @Input() requestedOptionMode: ProductEditorOptionModeV2 | null = null;
  @Input() crossSellProductId: number | null = null;
  @Input() scrollToSection: string | null = null;
  @Output() closeRequested = new EventEmitter<void>();
  @Output() productResolved = new EventEmitter<number>();
  @Output() productPersisted = new EventEmitter<void>();
  @Output() productCreatedForNext = new EventEmitter<{ type: ProductTypeV2; categoryId: number | null }>();
  @Output() surfaceChangeRequested = new EventEmitter<{
    surfaceMode: ProductEditorSurfaceV2;
    focusGroupId?: number | string | null;
    groupDraftMode?: ProductEditorGroupDraftModeV2 | null;
    startWithLibrary?: boolean;
    optionMode?: ProductEditorOptionModeV2 | null;
  }>();

  empresa: any;
  editor: ProductEditorVM | null = null;
  loading = true;
  isMobile = false;
  saveState = '';
  saveStateMuted = true;
  fiscalValidationMessage = '';
  isNewProduct = false;
  activeProductTab: ProductEditorTabV2 = 'info';
  showAdvanced = false;
  infoPanelOpen = false;
  previewOpen = false;
  libraryOpen = false;
  groupPanelOpen = false;
  readonly confirmacao = new ConfirmacaoV2();
  saveError: { message: string; key: string | null } | null = null;
  saveRetrying = false;
  brindeDesligadoPeloPreco = false;
  sectionPromotionOpen = false;
  sectionAvailabilityOpen = false;
  sectionClassificationOpen = false;
  groupDraft: ChoiceGroupVM | null = null;
  editingGroupId: number | string | null = null;
  draftOptions: ChoiceOptionVM[] = [];
  draftOptionInput = '';
  groupPanelTitle = 'Novo adicional';
  librarySearch = '';
  libraryFilter = 'Todos';
  libraryLoading = false;
  libraryItems: LibraryGroupVM[] = [];
  availableTags: any[] = [];
  templates: any[] = [];
  expandedGroups: Record<string, boolean> = {};
  optionMode: ProductEditorOptionModeV2 = 'review';
  optionSearch = '';
  optionFilter: 'all' | 'active' | 'inactive' = 'all';
  optionSort: ProductEditorOptionSortV2 = 'name-asc';
  batchPriceInput = '';
  batchSelection: Record<string, boolean> = {};
  groupOptionModes: Record<string, ProductEditorOptionModeV2> = {};
  groupOptionSearchState: Record<string, string> = {};
  groupOptionFilterState: Record<string, 'all' | 'active' | 'inactive'> = {};
  groupOptionSortState: Record<string, ProductEditorOptionSortV2> = {};
  batchSheetOpen = false;
  batchAdjustMode: BatchPriceAdjustMode = 'fixed';
  batchAdjustDirection: BatchPriceAdjustDirection = 'increase';
  batchAdjustValue = '';
  reorderSheetOpen = false;
  reorderList: ChoiceGroupVM[] = [];
  reorderDirty = false;
  reorderErrorMsg = '';
  reorderShaking = false;
  reorderApplying = false;
  editSheetOpen = false;
  editingOptionId: string | number | null = null;
  editingOptionName = '';
  editingOptionDescription = '';
  editingOptionPrice: number | null = null;
  editingOptionActive = true;
  editingOptionDisponivelParaDelivery = true;
  editingOptionDisponivelNaMesa = true;
  groupFormCollapsedMobile = true;
  unidades: any[] = [];
  temModuloFidelidade = false;
  temModuloPedidos = false;
  temModuloFiscal = false;
  temModuloEstoque = false;
  temModuloTabelaPrecos = false;
  temModuloComissionamento = false;
  comissoes: any[] = [];
  tabelaPrecosTargetKey: string | null = null;
  sectionFiscalOpen = false;
  sectionFidelidadeOpen = false;
  sectionEstoqueOpen = false;
  sectionTabelaPrecosOpen = true;
  sectionComissionamentoOpen = true;
  sectionMassaOpen = false;
  sectionBordaOpen = false;
  dadosFiscais: { origens: any[]; tiposTributacaoIPI: any[]; selosControleIPI: any[] } | null = null;
  fiscalLoading = false;
  fiscalNcmOptions: ProductFiscalNcmOptionVM[] = [];
  fiscalNcmSelecionado: ProductFiscalNcmOptionVM | null = null;
  fiscalNcmLoading = false;
  fiscalCestOptions: ProductFiscalCestOptionVM[] = [];
  fiscalCestSelecionado: ProductFiscalCestOptionVM | null = null;
  fiscalCestLoading = false;
  creationImagePreview: string | null = null;
  creationErrors: CreationErrorsV2 = {};
  readonly descricaoMaxLength = 1000;
  justCreated = false;
  adicionalActionBarState: { creationPhase: 'config' | 'full'; saveFooterState: 'hidden' | 'dirty' | 'saving' | 'saved' } = {
    creationPhase: 'config',
    saveFooterState: 'hidden'
  };
  tabelaPrecosLoading = false;
  tabelaPrecosSaving = false;
  tabelaPrecosLinhas: ProductPriceTableRowVM[] = [];

  private fiscalNcmSearchTimer: any = null;
  private fiscalCestSearchTimer: any = null;
  private lastLoadSignature = '';
  private optionBrowserContextKey = '';
  private optionRuntimeKeys = new WeakMap<ChoiceOptionVM, string>();
  private optionRuntimeKeySequence = 0;
  private empresaSubscription?: Subscription;
  private moduloFidelidadeSubscription?: Subscription;
  private moduloPedidoSubscription?: Subscription;
  private moduloFiscalSubscription?: Subscription;
  private moduloEstoqueSubscription?: Subscription;
  private moduloTabelaPrecosSubscription?: Subscription;
  private moduloComissionamentoSubscription?: Subscription;
  private routeParamsSubscription?: Subscription;
  private routeQueryParamsSubscription?: Subscription;

  constructor(
    private constantsService: ConstantsService,
    private facade: ProdutosV2FacadeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private httpClient: HttpClient,
    private autorizacaoService: AutorizacaoService,
    private tabelaPrecosService: TabelaPrecosService,
    private comissionamentoService: ComissionamentoService,
    private dialogService: DialogService,
    private elementRef: ElementRef,
    private catalogosService: CatalogosService
  ) {
    this.handleResize();
  }

  ngOnInit(): void {
    if (!this.embedded) {
      const productId = this.activatedRoute.snapshot.params['id'];
      const tipo = this.activatedRoute.snapshot.queryParams['tipo'];
      this.router.navigate(['/admin/fidelidade/produtos-v2'], {
        queryParams: productId
          ? { produtoDrawer: productId }
          : { novoTipoDrawer: tipo || 'normal' },
        replaceUrl: true
      });
      return;
    }

    this.empresaSubscription = this.constantsService.empresa$.subscribe(async (empresa) => {
      if (!empresa?.catalogo?.id) return;
      this.empresa = empresa;
      await this.syncContextLoad();
    });

    this.moduloFidelidadeSubscription = this.constantsService.moduloFidelidade$.subscribe((v) => this.temModuloFidelidade = !!v);
    this.moduloPedidoSubscription = this.constantsService.moduloPedido$.subscribe((v) => this.temModuloPedidos = !!v);
    this.moduloFiscalSubscription = this.constantsService.moduloFiscal$.subscribe((v) => this.temModuloFiscal = !!v);
    this.moduloEstoqueSubscription = this.constantsService.moduloEstoque$.subscribe((v) => this.temModuloEstoque = !!v);
    this.moduloTabelaPrecosSubscription = this.constantsService.moduloTabelaPrecos$.subscribe((v) => {
      this.temModuloTabelaPrecos = !!v;
      if (this.temModuloTabelaPrecos && this.editor?.id && !this.tabelaPrecosLinhas.length) {
        void this.carregueTabelaPrecosProduto();
      }
    });
    this.moduloComissionamentoSubscription = this.constantsService.moduloComissionamento$.subscribe((v) => {
      this.temModuloComissionamento = !!v;
      if (this.temModuloComissionamento) {
        void this.carregueComissoes();
      }
    });

    this.routeParamsSubscription = this.activatedRoute.params.subscribe(async () => {
      if (this.embedded || !this.empresa) return;
      await this.syncContextLoad();
    });

    this.routeQueryParamsSubscription = this.activatedRoute.queryParams.subscribe(async () => {
      if (this.embedded || !this.empresa) return;
      await this.syncContextLoad();
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!this.embedded || !this.empresa) return;
    if (
      changes['productId']
      || changes['newProductType']
      || changes['initialCategoryId']
      || changes['creationSeed']
      || changes['startWithPreview']
      || changes['startWithLibrary']
      || changes['surfaceMode']
      || changes['focusGroupId']
      || changes['groupDraftMode']
      || changes['requestedOptionMode']
      || changes['crossSellProductId']
      || changes['scrollToSection']
    ) {
      await this.syncContextLoad(true);
    }
  }

  ngOnDestroy(): void {
    this.empresaSubscription?.unsubscribe();
    this.moduloFidelidadeSubscription?.unsubscribe();
    this.moduloPedidoSubscription?.unsubscribe();
    this.moduloFiscalSubscription?.unsubscribe();
    this.moduloEstoqueSubscription?.unsubscribe();
    this.moduloTabelaPrecosSubscription?.unsubscribe();
    this.moduloComissionamentoSubscription?.unsubscribe();
    this.routeParamsSubscription?.unsubscribe();
    this.routeQueryParamsSubscription?.unsubscribe();
    if (this.fiscalNcmSearchTimer) clearTimeout(this.fiscalNcmSearchTimer);
    if (this.fiscalCestSearchTimer) clearTimeout(this.fiscalCestSearchTimer);
    // Última rede de proteção: dispara (sem esperar) o que ficou no debounce.
    void this.flushPendingSaves();
  }

  @HostListener('window:resize')
  handleResize() {
    this.isMobile = window.innerWidth < 1024;
    if (!this.isMobile) {
      this.sectionPromotionOpen = true;
      this.sectionAvailabilityOpen = true;
      this.sectionClassificationOpen = true;
    }
  }

  get categorias(): any[] {
    return this.empresa?.catalogo?.categorias || [];
  }

  get catalogoCompartilhado(): boolean {
    return !!this.empresa?.catalogo?.compartilhado;
  }

  get precoPorEmpresa(): boolean {
    return !!this.empresa?.catalogo?.precoPorEmpresa;
  }

  get disponibilidadePorEmpresa(): boolean {
    return !!this.empresa?.catalogo?.disponibilidadePorEmpresa;
  }

  newCategoryOpen = false;
  newCategoryName = '';
  savingCategory = false;

  openNewCategory(): void {
    if (!this.podeEditarProdutos) return;
    this.newCategoryOpen = true;
    this.newCategoryName = '';
    setTimeout(() => {
      const input = this.elementRef.nativeElement.querySelector('.pv2-new-category input') as HTMLInputElement | null;
      input?.focus();
    });
  }

  cancelNewCategory(): void {
    this.newCategoryOpen = false;
    this.newCategoryName = '';
  }

  async saveNewCategory(): Promise<void> {
    const nome = String(this.newCategoryName || '').trim();
    if (!nome || this.savingCategory || !this.editor) return;

    const existente = this.categorias.find((categoria) => String(categoria.nome || '').trim().toLowerCase() === nome.toLowerCase());
    if (existente) {
      this.editor.categoryId = existente.id;
      this.onBasicInfoChange();
      this.cancelNewCategory();
      return;
    }

    this.savingCategory = true;
    try {
      const catalogo = this.empresa.catalogo;
      const categoria: any = { nome, impressoras: [], areasDestino: [] };
      const resposta = await this.catalogosService.salveCategoria(catalogo, categoria, !this.empresa?.id);
      categoria.id = resposta?.id;
      categoria.posicao = resposta?.posicao;
      categoria.nivel = 1;
      // Reatribui o array para o dropdown e o catálogo (mesma referência de empresa) enxergarem a nova categoria.
      catalogo.categorias = [...(catalogo.categorias || []), categoria];
      this.editor.categoryId = categoria.id;
      this.onBasicInfoChange();
      this.cancelNewCategory();
      this.notificationService.showSuccess(`Categoria "${nome}" criada.`);
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível criar a categoria.');
    } finally {
      this.savingCategory = false;
    }
  }

  get podeEditarProdutos(): boolean {
    return !this.empresa?.id || !this.catalogoCompartilhado;
  }

  get podeEditarPrecos(): boolean {
    return this.podeEditarProdutos
      || (this.precoPorEmpresa && RotaGuardClient.alterarPrecoCardapioCompartilhado(this.autorizacaoService.getUser()));
  }

  get podeEditarEstruturaAdicional(): boolean {
    return this.podeEditarProdutos;
  }

  get podeEditarPrecoOpcoes(): boolean {
    return this.podeEditarPrecos;
  }

  get podeEditarDisponibilidadeOpcoes(): boolean {
    return this.podeEditarProdutos || this.disponibilidadePorEmpresa;
  }

  get podeEditarExibicaoOpcoes(): boolean {
    return RotaGuardClient.podeEditarExibicaoOpcoes(this.autorizacaoService.getUser(), this.empresa);
  }

  get podeEditarAlgumaOpcao(): boolean {
    return this.podeEditarEstruturaAdicional || this.podeEditarPrecoOpcoes
      || this.podeEditarDisponibilidadeOpcoes || this.podeEditarExibicaoOpcoes;
  }

  verPrecosTabela(targetKey?: string | null): void {
    if (!this.editor?.id) return;

    if (targetKey) this.tabelaPrecosTargetKey = targetKey;
    this.sectionTabelaPrecosOpen = true;
    setTimeout(() => {
      document.getElementById('pv2-tabela-precos-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  }

  async carregueComissoes(): Promise<void> {
    try {
      this.comissoes = await this.comissionamentoService.listeComissoes() as any[] || [];
    } catch (error: any) {
      this.notificationService.showError(error?.message || error || 'Não foi possível carregar as comissões.');
    }
  }

  comissaoSelecionada(): any {
    if (!this.editor?.raw?.comissao?.id) return null;
    return this.comissoes.find((comissao) => Number(comissao.id) === Number(this.editor!.raw.comissao.id)) || this.editor.raw.comissao;
  }

  compareComissao(comissaoA: any, comissaoB: any): boolean {
    return Number(comissaoA?.id || 0) === Number(comissaoB?.id || 0);
  }

  async onComissaoChange(): Promise<void> {
    if (!this.editor || !this.podeEditarProdutos) return;
    try {
      await this.markSaving();
      await this.facade.salveProduto(this.editor.raw);
      await this.recarregueEditor(false);
      this.markSaved();
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível salvar a comissão do produto.');
    }
  }

  targetKeyTabelaPrecosTamanho(option: ChoiceOptionVM): string | null {
    const id = option?.raw?.id || option?.id;
    return id ? `PRODUTO_TAMANHO:${Number(id)}` : null;
  }

  get deveExibirAvisoCatalogoRede(): boolean {
    return !!this.empresa?.id && this.catalogoCompartilhado && !this.podeEditarProdutos;
  }

  get textoPermissoesCatalogoRede(): string {
    const permissoes: string[] = [];
    if (this.podeEditarPrecos) permissoes.push('preços desta loja');
    if (this.podeEditarDisponibilidadeOpcoes) permissoes.push('disponibilidade/ativação');
    if (this.podeEditarExibicaoOpcoes) permissoes.push('onde exibir das opções');

    if (!permissoes.length) {
      return 'Neste contexto, nenhuma edição local foi liberada para este usuário.';
    }

    return 'Neste contexto, você ainda pode editar: ' + permissoes.join(' e ') + '.';
  }

  get mensagemBloqueioCatalogoRede(): string {
    return 'Esta informação é controlada pelo catálogo da rede. Solicite a edição ao responsável pelo catálogo da rede.';
  }

  get vendidoPorPeso(): boolean {
    return this.editor?.tipoDeVenda === 'Peso';
  }

  get vendidoPorUnidade(): boolean {
    return !this.editor?.tipoDeVenda || this.editor?.tipoDeVenda === 'Unidade';
  }

  get fiscalPodeBuscarCest(): boolean {
    return /^\d{8}$/.test(this.normalizeNcm(this.editor?.fiscal?.ncm));
  }

  get hasAdvancedValues(): boolean {
    if (!this.editor) return false;
    return !!(
      this.editor.codigoPdv ||
      (this.editor.incremento != null && this.editor.incremento > 1) ||
      (this.editor.qtdeMinima != null && this.editor.qtdeMinima !== 1 && this.editor.qtdeMinima !== 0) ||
      (this.editor.qtdMaxima != null && this.editor.qtdMaxima > 0)
    );
  }

  obtenhaFormatoPrecoV2(): string {
    if (!this.editor?.tipoDeVenda || this.editor.tipoDeVenda !== 'Peso') {
      return '$0.00';
    }

    return '$ 0.00/ kg';
  }

  get showExibirNoSite(): boolean {
    return this.temModuloFidelidade && !this.temModuloPedidos;
  }

  get showNaoSincronizar(): boolean {
    return this.catalogoCompartilhado;
  }

  get pontuarFidelidade(): boolean {
    if (!this.empresa?.integracaoPedidoFidelidade) return false;
    const tipoAcumulo = this.empresa.integracaoPedidoFidelidade?.plano?.tipoDePontuacao?.tipo;
    return tipoAcumulo === 'qtde-variavel-por-atividade' || tipoAcumulo === 'cashback';
  }

  get acumulaReais(): boolean {
    if (!this.empresa?.integracaoPedidoFidelidade) return false;
    return this.empresa.integracaoPedidoFidelidade?.plano?.tipoDeAcumulo === 'Reais';
  }

  get filteredLibraryItems(): LibraryGroupVM[] {
    const term = this.librarySearch.trim().toLowerCase();
    return this.libraryItems.filter((item) => {
      const matchSearch = !term || item.name.toLowerCase().includes(term);
      if (this.libraryFilter === 'Mais usados') return matchSearch && item.sharedCount > 0;
      if (this.libraryFilter === 'Recentes') return matchSearch && item.sharedCount <= 3;
      return matchSearch;
    });
  }

  get activeSurfaceMode(): ProductEditorSurfaceV2 {
    if (this.embedded) {
      return this.surfaceMode || 'overview';
    }

    return (this.activatedRoute.snapshot.queryParams.drawerSurface
      || this.activatedRoute.snapshot.queryParams.surface
      || 'overview') as ProductEditorSurfaceV2;
  }

  get isOverviewSurface(): boolean {
    return this.activeSurfaceMode === 'overview';
  }

  get isGroupDetailSurface(): boolean {
    return this.activeSurfaceMode === 'group-detail';
  }

  get shouldShowInlineLibrary(): boolean {
    return this.libraryOpen && this.isGroupDetailSurface;
  }

  get focusedGroup(): ChoiceGroupVM | null {
    if (!this.editor) return null;
    const focusGroupId = this.getContextFocusGroupId();
    if (focusGroupId == null) return null;
    return this.editor.groups.find((grupo) => String(grupo.id) === String(focusGroupId)) || null;
  }

  get isCreatingGroupDetail(): boolean {
    return this.getContextGroupDraftMode() === 'create';
  }

  get isReviewMode(): boolean {
    return this.optionMode === 'review';
  }

  get isActivationMode(): boolean {
    return this.optionMode === 'activation';
  }

  get isBatchPriceMode(): boolean {
    return this.optionMode === 'batch-price';
  }

  get batchSelectedCount(): number {
    return Object.keys(this.batchSelection).filter((key) => this.batchSelection[key]).length;
  }

  get focusedGroupPricePresets(): number[] {
    const prices = new Set(
      (this.focusedGroup?.options || [])
        .map((option) => Number(option.price || 0))
        .filter((price) => Number.isFinite(price))
    );

    return Array.from(prices)
      .sort((a, b) => a - b)
      .slice(0, 6);
  }

  get filteredFocusedGroupOptions(): ChoiceOptionVM[] {
    const group = this.focusedGroup;
    if (!group) return [];

    const term = this.optionSearch.trim().toLowerCase();
    const filtered = (group.options || []).filter((option) => {
      const matchesSearch = !term || (option.name || '').toLowerCase().includes(term);
      if (!matchesSearch) return false;

      if (this.optionFilter === 'active') {
        return option.active !== false;
      }

      if (this.optionFilter === 'inactive') {
        return option.active === false;
      }

      return true;
    });

    return filtered.sort((left, right) => {
      if (this.optionSort === 'price-asc') {
        return Number(left.price || 0) - Number(right.price || 0)
          || String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
      }

      if (this.optionSort === 'price-desc') {
        return Number(right.price || 0) - Number(left.price || 0)
          || String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
      }

      return String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
    });
  }

  async carregueTela() {
    this.loading = true;
    try {
      const [tags, templates, unidades] = await Promise.all([
        this.facade.carregueTags(),
        this.facade.carregueTemplates(this.empresa.catalogo),
        this.facade.carregueUnidades()
      ]);
      this.availableTags = tags || [];
      this.templates = templates || [];
      this.unidades = unidades || [];

      const id = this.getContextProductId();
      if (id) {
        this.editor = await this.facade.carregueProduto(this.empresa, Number(id), this.templates);
      } else {
        const tipo = this.getContextProductType();
        let templatesParaCriacao = this.templates;
        if (tipo === 'pizza' && this.pizzaTemplateId) {
          const templateEspecifico = this.templates.find((t: any) => t.id === this.pizzaTemplateId);
          if (templateEspecifico) {
            templatesParaCriacao = [templateEspecifico];
          }
        }
        this.editor = this.facade.mapEditor(this.facade.crieProdutoNovo(tipo, this.empresa.catalogo, templatesParaCriacao), this.templates);
        const categoriaInicial = this.initialCategoryId != null
          ? this.categorias.find((categoria) => categoria.id === this.initialCategoryId)
          : null;
        if (categoriaInicial) {
          this.editor.categoryId = categoriaInicial.id;
          this.editor.category = categoriaInicial.nome;
          this.editor.raw.categoria = categoriaInicial;
        }
      }

      this.isNewProduct = !id;
      this.creationErrors = {};
      this.justCreated = false;
      this.showAdvanced = false;
      this.initializeExpandedGroups();
      this.tabelaPrecosLinhas = [];
      this.infoPanelOpen = false;
      this.groupPanelOpen = false;
      this.libraryOpen = false;
      this.previewOpen = false;

      if (!this.isMobile) {
        this.sectionPromotionOpen = true;
        this.sectionAvailabilityOpen = true;
        this.sectionClassificationOpen = true;
      }

      this.previewOpen = this.shouldStartWithPreview();
      this.initializeGroupDetailDraft();
      if (this.temModuloTabelaPrecos && this.editor?.id) {
        await this.carregueTabelaPrecosProduto();
      }
      if (this.shouldStartWithLibrary()) {
        await this.openLibrary();
      }
      if (this.scrollToSection === 'adicionais' && !this.isNewProduct) {
        this.activeProductTab = 'adicionais';
        this.scrollToSection = null;
      }
      if (this.scrollToSection === 'fotos' && !this.isNewProduct) {
        this.activeProductTab = 'photos';
        this.scrollToSection = null;
      }
      if (this.scrollToSection === 'tabela-precos') {
        this.activeProductTab = 'pricing';
        setTimeout(() => {
          this.verPrecosTabela();
          this.scrollToSection = null;
        }, 150);
      }
    } finally {
      this.loading = false;
    }
  }

  async recarregueEditor(preservePanels = true) {
    if (!this.editor) return;

    const infoOpen = this.infoPanelOpen;
    const previewOpen = this.previewOpen;
    const libraryOpen = this.libraryOpen;
    const sectionPromotionOpen = this.sectionPromotionOpen;
    const sectionAvailabilityOpen = this.sectionAvailabilityOpen;
    const sectionClassificationOpen = this.sectionClassificationOpen;
    const sectionTabelaPrecosOpen = this.sectionTabelaPrecosOpen;
    const currentExpanded = { ...this.expandedGroups };
    const previousImage = this.editor.image;

    let newEditor: ProductEditorVM;
    if (this.editor.id) {
      newEditor = await this.facade.carregueProduto(this.empresa, Number(this.editor.id), this.templates);
    } else {
      newEditor = this.facade.mapEditor(this.editor.raw, this.templates);
    }

    if (!newEditor.image && previousImage) {
      newEditor.image = previousImage;
    }
    this.editor = newEditor;

    this.expandedGroups = {};
    this.editor.groups.forEach((grupo) => {
      const key = this.groupKey(grupo);
      this.expandedGroups[key] = currentExpanded[key] !== false;
    });

    this.initializeGroupDetailDraft();

    if (preservePanels) {
      this.infoPanelOpen = infoOpen;
      this.previewOpen = previewOpen;
      this.libraryOpen = libraryOpen;
      this.sectionPromotionOpen = sectionPromotionOpen;
      this.sectionAvailabilityOpen = sectionAvailabilityOpen;
      this.sectionClassificationOpen = sectionClassificationOpen;
      this.sectionTabelaPrecosOpen = sectionTabelaPrecosOpen;
    }

    if (this.temModuloTabelaPrecos && this.editor?.id) {
      await this.carregueTabelaPrecosProduto();
    }
  }

  async carregueTabelaPrecosProduto(): Promise<void> {
    if (!this.editor?.id || !this.empresa?.catalogo?.id || !this.temModuloTabelaPrecos) return;
    this.tabelaPrecosLoading = true;
    try {
      this.tabelaPrecosLinhas = await this.tabelaPrecosService.listeProduto(Number(this.editor.id), Number(this.empresa.catalogo.id));
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.tabelaPrecosLoading = false;
    }
  }

  marqueTabelaPrecoAlterada(linha: ProductPriceTableRowVM): void {
    linha.dirty = true;
  }

  async salveTabelaPrecosProduto(): Promise<void> {
    if (!this.editor?.id || !this.empresa?.catalogo?.id || !this.podeEditarPrecos) return;
    const alteradas = this.tabelaPrecosLinhas.filter((linha) => linha.dirty).map((linha) => linha.item);
    if (!alteradas.length) return;
    this.tabelaPrecosSaving = true;
    try {
      this.tabelaPrecosLinhas = await this.tabelaPrecosService.salveProduto(
        Number(this.editor.id),
        Number(this.empresa.catalogo.id),
        alteradas
      );
      this.notificationService.showSuccess('Tabela de precos do produto salva.');
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.tabelaPrecosSaving = false;
    }
  }

  canalTabelaPrecoLabel(canal: string | null): string {
    const labels: any = {
      LOJA: 'Loja',
      DELIVERY: 'Loja',
      RETIRADA: 'Loja',
      MESA: 'Mesa',
      BALCAO: 'Balcao',
      IFOOD: 'iFood',
      '99FOOD': '99Food',
      KEETA: 'Keeta'
    };
    if (!canal) return 'Todos';
    return String(canal)
      .split(',')
      .map((item) => item.trim())
      .filter((item) => !!item)
      .map((item) => labels[item] || item)
      .join(', ') || 'Todos';
  }

  onPizzaOptionChanged(adicional: PizzaAdditionalVM | null | undefined) {
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (adicional) adicional.dirty = true;
  }

  async savePizzaAdicional(adicional: PizzaAdditionalVM | null | undefined) {
    if (!this.podeEditarAlgumaOpcao) {
      this.notifySharedCatalogBlocked();
      return;
    }
    if (!adicional || !this.editor || adicional.saving) return;
    try {
      await this.facade.salvePizzaAdicional(this.empresa.catalogo, this.editor.raw, adicional, this.empresa);
      this.notificationService.showSuccess(`${adicional.name}s salvas com sucesso!`);
    } catch (err) {
      this.notificationService.showError(`Erro ao salvar ${adicional.name.toLowerCase()}s.`);
    }
  }

  async goBack() {
    // Grava o que estava no debounce antes de sair: fechar não pode comer a última edição.
    // O editor de adicional embutido tem o próprio debounce, então também precisa descarregar.
    await this.adicionalEditorComponent?.flushPendingSave();
    await this.flushPendingSaves();

    if (this.isGroupDetailSurface) {
      this.requestSurfaceChange('overview');
      return;
    }

    if (this.embedded) {
      this.closeRequested.emit();
      return;
    }

    await this.navigateToAdminCatalog();
  }

  openInfoPanel() {
    if (this.isGroupDetailSurface) return;
    this.infoPanelOpen = true;
  }

  closeInfoPanel() {
    this.infoPanelOpen = false;
  }

  openHistorico() {
    if (!this.editor?.id) return;

    const windowRef: DialogRef = this.dialogService.open({
      title: 'Histórico do produto',
      content: HistoricoProdutoComponent,
      minWidth: 250,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.content.instance.produto = { id: this.editor.id };
    windowRef.result.subscribe(() => {}, () => {});
  }

  openPreview() {
    if (this.isGroupDetailSurface) return;
    this.previewOpen = true;
  }

  closePreview() {
    this.previewOpen = false;
  }

  onEditorImageError() {
    if (!this.editor) return;

    const nextCandidateIndex = (this.editor.imageCandidateIndex ?? 0) + 1;
    const nextCandidate = this.editor.imageCandidates?.[nextCandidateIndex] || null;

    if (nextCandidate) {
      this.editor.imageCandidateIndex = nextCandidateIndex;
      this.editor.image = nextCandidate;
      return;
    }

    this.editor.image = null;
  }

  hasEditorImage(): boolean {
    return !!this.editor?.image;
  }

  getEditorPlaceholder(): string {
    if (!this.editor) return '🍽️';
    return this.editor.emoji || (this.editor.type === 'pizza' ? '🍕' : '🍽️');
  }

  async salveImagensProduto(fnRetorno: Function) {
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('As imagens do produto estão bloqueadas neste catálogo compartilhado.');
      return;
    }
    try {
      await this.markSaving();
      await this.facade.salveImagensProduto(this.empresa, this.editor!.raw);
      await this.recarregueEditor(true);
      this.markSaved();
      fnRetorno();
    } catch (erro: any) {
      // O upload agora salva sozinho (A8), então o erro precisa aparecer como os
      // outros do auto-save, na faixa persistente do B6.
      this.handleSaveError(erro, 'Não foi possível salvar as fotos do produto.');
      fnRetorno(erro);
    }
  }

  async openLibrary() {
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('A biblioteca está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (this.embedded && this.isOverviewSurface) {
      this.requestSurfaceChange('group-detail', null, 'create', true);
      return;
    }

    this.libraryLoading = true;
    this.libraryOpen = true;
    try {
      this.libraryItems = await this.facade.carregueBiblioteca(this.empresa.catalogo, this.librarySearch, this.editor?.raw || this.editor || null);
    } finally {
      this.libraryLoading = false;
    }
  }

  closeLibrary() {
    this.libraryOpen = false;
  }

  async openDedicatedEditor() {
    await this.promoteToDedicatedEditor(undefined, true);
  }

  async refreshLibrary() {
    this.libraryLoading = true;
    try {
      this.libraryItems = await this.facade.carregueBiblioteca(this.empresa.catalogo, this.librarySearch, this.editor?.raw || this.editor || null);
    } finally {
      this.libraryLoading = false;
    }
  }

  toggleGroup(grupo: ChoiceGroupVM) {
    const key = this.groupKey(grupo);
    this.expandedGroups[key] = !this.expandedGroups[key];
  }

  isExpanded(grupo: ChoiceGroupVM): boolean {
    return this.expandedGroups[this.groupKey(grupo)] !== false;
  }

  onGroupCardPressed(grupo: ChoiceGroupVM) {
    if (grupo.kind === 'adicional') {
      this.openGlobalAdditional(grupo);
      return;
    }

    if (this.embedded && this.isOverviewSurface) {
      this.requestSurfaceChange('group-detail', grupo.id, 'edit');
      return;
    }

    if (this.shouldUseDenseGroupSummary(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    // A12: opção de adicional se edita num lugar só, o editor de adicional.
    // A expansão inline sobrou para os tamanhos da pizza, que têm estrutura fixa
    // e não passam por aquele editor.
    if (!this.isFixedGroup(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    this.toggleGroup(grupo);
  }

  async openGroupPanel(grupo?: ChoiceGroupVM) {
    if (!this.editor) return;

    if (grupo?.kind === 'adicional') {
      this.openGlobalAdditional(grupo);
      return;
    }

    if (grupo && !this.canEditGroupStructure(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    if (grupo && this.isFixedGroup(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    if (!this.embedded && grupo && this.shouldUseDenseGroupSummary(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A estrutura do adicional está bloqueada neste catálogo compartilhado.');
      return;
    }

    if (this.embedded) {
      this.requestSurfaceChange('group-detail', grupo?.id ?? null, grupo ? 'edit' : 'create');
      return;
    }

    const targetGroup = grupo || null;

    if (targetGroup) {
      this.groupPanelTitle = 'Editar adicional';
      this.editingGroupId = targetGroup.id;
      this.groupDraft = this.cloneGroup(targetGroup);
    } else {
      this.groupPanelTitle = 'Novo adicional';
      this.editingGroupId = null;
      this.groupDraft = this.buildEmptyGroupDraft();
    }

    this.groupPanelOpen = true;
  }

  closeGroupPanel() {
    this.groupPanelOpen = false;
    this.groupDraft = null;
    this.editingGroupId = null;
    this.draftOptions = [];
    this.draftOptionInput = '';
  }

  async saveGroupPanel() {
    if (!this.editor || !this.groupDraft) return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A estrutura do adicional está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (this.isFixedGroup(this.groupDraft)) {
      this.notificationService.showError('Os tamanhos da pizza usam uma estrutura fixa.');
      return;
    }

    const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de criar o adicional.');
    if (!persisted) return;

    const target = this.editingGroupId != null
      ? this.editor.groups.find((grupo) => String(grupo.id) === String(this.editingGroupId))
      : null;

    let grupo = target;
    if (!grupo) {
      grupo = this.cloneGroup(this.groupDraft);
      this.editor.groups.push(grupo);
    }

    grupo.name = this.groupDraft.name || 'Novo adicional';
    grupo.type = this.groupDraft.type;
    grupo.multiplicaQuantidadeProduto = this.groupDraft.multiplicaQuantidadeProduto !== false;
    grupo.required = this.groupDraft.required;
    grupo.min = Number(this.groupDraft.min || 0);
    grupo.max = Number(this.groupDraft.max || 1);
    grupo.chargeType = this.groupDraft.chargeType;
    grupo.shared = this.groupDraft.shared;
    grupo.description = this.describeDraft(grupo);

    if (!target && this.draftOptions.length > 0) {
      grupo.options = this.draftOptions.map((opt, i) => ({
        ...opt, order: i,
        raw: { nome: opt.name, valor: opt.price, disponivel: opt.active, nova: true }
      }));
    }

    try {
      await this.markSaving();
      await this.facade.salveGrupo(this.empresa.catalogo, this.editor.raw, grupo,
        this.podeEditarExibicaoOpcoes);

      if (grupo.kind === 'adicional' && grupo.raw) {
        this.editor.raw.camposAdicionais = this.editor.raw.camposAdicionais || [];
        const existing = (this.editor.raw.camposAdicionais || []).find((item: any) => item.id === grupo.raw.id);
        if (!existing) {
          this.editor.raw.camposAdicionais.push(grupo.raw);
        }
      }

      const savedGroupId = grupo.raw?.id ?? grupo.id ?? null;
      const savedGroupName = grupo.name;

      await this.recarregueEditor();

      if (this.isGroupDetailSurface) {
        const persistedGroup = this.editor.groups.find((item) => {
          if (savedGroupId != null && item.id != null) {
            return String(item.id) === String(savedGroupId);
          }

          return item.name === savedGroupName;
        }) || null;

        this.groupDraft = persistedGroup ? this.cloneGroup(persistedGroup) : this.buildEmptyGroupDraft();
        this.editingGroupId = persistedGroup?.id ?? null;

        if (this.embedded) {
          this.requestSurfaceChange('group-detail', persistedGroup?.id ?? null, persistedGroup ? 'edit' : 'create', this.libraryOpen);
        }
      } else {
        this.closeGroupPanel();
      }

      this.draftOptions = [];
      this.draftOptionInput = '';
      this.markSaved();
      this.notificationService.showSuccess('Adicional salvo.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível salvar o adicional.');
    }
  }

  async removeGroup(grupo: ChoiceGroupVM) {
    if (!this.editor || grupo.kind === 'pizza-sizes') return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A exclusão de adicionais está bloqueada neste catálogo compartilhado.');
      return;
    }
    const ok = await this.confirmacao.confirme(
      grupo.shared ? 'Remover adicional deste produto?' : 'Excluir adicional?',
      grupo.shared
        ? `"${grupo.name}" está compartilhado com outros produtos. Ele será desvinculado apenas deste produto.`
        : `"${grupo.name}" e todas as suas opções serão removidos deste produto.`,
      grupo.shared ? 'Remover deste produto' : 'Excluir'
    );
    if (!ok) return;

    try {
      await this.markSaving();
      await this.facade.removaGrupo(this.editor.raw, this.empresa.catalogo, grupo);
      this.editor.groups = this.editor.groups.filter((item) => item !== grupo);
      this.editor.raw.camposAdicionais = (this.editor.raw.camposAdicionais || []).filter((item: any) => item.id !== grupo.raw?.id);
      await this.recarregueEditor(false);

      if (this.isGroupDetailSurface) {
        this.groupDraft = null;
        this.editingGroupId = null;

        if (this.embedded) {
          this.requestSurfaceChange('overview');
        } else {
          await this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
              surface: null,
              grupo: null,
              groupMode: null,
              library: null
            },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        }
      }

      this.markSaved();
      this.notificationService.showSuccess('Adicional removido.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível remover o adicional.');
    }
  }

  async addOption(grupo: ChoiceGroupVM) {
    if (!this.editor || grupo.kind === 'pizza-sizes') return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A inclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    const editableGroup = grupo.shared ? await this.prepareSharedGroup(grupo) : grupo;
    if (!editableGroup) return;

    const option: ChoiceOptionVM = {
      id: null,
      name: '',
      price: 0,
      active: true,
      disponivelParaDelivery: true,
      disponivelNaMesa: true,
      order: editableGroup.options.length,
      raw: { nova: true, disponivelParaDelivery: true, disponivelNaMesa: true }
    };

    this.syncOptionToRaw(editableGroup, option, false);
    editableGroup.options.push(option);
    if (!editableGroup.raw.opcoesDisponiveis) editableGroup.raw.opcoesDisponiveis = [];
    editableGroup.raw.opcoesDisponiveis.push(option.raw);
    this.scheduleGroupSave(editableGroup);
  }

  addDraftOptionFromInput(): void {
    const name = this.draftOptionInput.trim();
    if (!name) return;
    this.draftOptions.push({
      id: null, name, price: 0, active: true,
      disponivelParaDelivery: true, disponivelNaMesa: true,
      order: this.draftOptions.length,
      raw: { nova: true, disponivelParaDelivery: true, disponivelNaMesa: true }
    });
    this.draftOptionInput = '';
  }

  removeDraftOption(index: number): void {
    this.draftOptions.splice(index, 1);
    this.draftOptions.forEach((opt, i) => opt.order = i);
  }

  onOptionChanged(grupo: ChoiceGroupVM, option: ChoiceOptionVM, changeType: 'structure' | 'price' | 'availability' = 'structure') {
    if (changeType === 'structure' && !this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A estrutura da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    if (changeType === 'price' && !this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço da opção está bloqueado neste catálogo compartilhado.');
      return;
    }

    if (changeType === 'availability' && !this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    this.syncOptionToRaw(grupo, option);
    this.scheduleGroupSave(grupo);
  }

  removeOption(grupo: ChoiceGroupVM, option: ChoiceOptionVM) {
    if (grupo.kind === 'pizza-sizes') return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A exclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }

    this.syncOptionToRaw(grupo, option, false);
    if (option.raw?.id) {
      option.raw.removida = true;
      delete option.raw.atualizar;
    } else if (grupo.raw?.opcoesDisponiveis) {
      grupo.raw.opcoesDisponiveis = grupo.raw.opcoesDisponiveis.filter((rawOption: any) => rawOption !== option.raw);
    }

    grupo.options = grupo.options.filter((item) => item !== option);
    this.scheduleGroupSave(grupo);
  }

  adicionarQuantidadeKit(): void {
    this.editor.raw.tamanhos = this.editor.raw.tamanhos || [];
    this.editor.raw.tamanhos.push({descricao: '', qtdeUnidades: 100, preco: 0, disponivel: true});
  }

  alterarModalidadeKit(): void {
    if (this.editor.raw.configKit.modalidadeQuantidade === 'FECHADA' && !this.editor.raw.tamanhos?.length)
      this.adicionarQuantidadeKit();
    this.onBasicInfoChange();
  }

  async converterEmKit(): Promise<void> {
    this.editor.raw.tipo = 'kit';
    this.editor.type = 'kit';
    this.editor.raw.configKit = null;
    this.onBasicInfoChange();
    this.notificationService.showSuccess('Produto convertido. Cadastre os grupos de composição na aba Adicionais.');
  }

  onBasicInfoChange() {
    if (!this.editor || (!this.podeEditarProdutos && !this.podeEditarPrecos)) return;
    this.sincronizeBrindeComPreco();
    this.syncBasicInfoToRaw();

    if (this.isNewProduct) {
      this.clearResolvedCreationErrors();
      return;
    }

    this.scheduleSave('info', async () => {
      try {
        await this.markSaving();
        await this.facade.salveProduto(this.editor!.raw);
        await this.syncResolvedProductState(true);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar as informações básicas.');
      }
    }, 800);
  }

  async saveNewProduct(next: 'configure' | 'new' = 'configure') {
    if (!this.editor) return;
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('A criação de produtos está bloqueada neste catálogo compartilhado.');
      return;
    }
    this.syncBasicInfoToRaw();

    this.creationErrors = this.validateCreation();
    const firstInvalid = (Object.keys(this.creationErrors) as Array<keyof CreationErrorsV2>)[0];
    if (firstInvalid) {
      this.activeProductTab = 'info';
      this.focusCreationField(firstInvalid);
      return;
    }

    try {
      await this.markSaving();
      await this.facade.salveProduto(this.editor.raw);

      if (next === 'new') {
        // Salvar e novo: persiste (com foto), avisa o catálogo e deixa ele reabrir um formulário limpo
        // na mesma categoria. Não emite productResolved para não trocar o drawer para o produto criado.
        if (this.creationImagePreview && this.editor.raw?.id) {
          await this.uploadCreationImage();
        }
        const nomeCriado = this.editor.name;
        const categoryId = this.editor.categoryId ?? null;
        const type = this.editor.type;
        this.creationImagePreview = null;
        this.creationErrors = {};
        this.markSaved();
        this.notificationService.showSuccess(`"${nomeCriado}" criado. Pode cadastrar o próximo.`);
        if (this.embedded) {
          this.productCreatedForNext.emit({ type, categoryId });
        } else {
          await this.router.navigate(['/admin/fidelidade/produtos-v2'], {
            queryParams: { novoTipoDrawer: type, categoriaDrawer: categoryId },
            replaceUrl: true
          });
        }
        return;
      }

      await this.syncResolvedProductState(true);

      if (this.creationImagePreview && this.editor.raw?.id) {
        await this.uploadCreationImage();
      }

      this.isNewProduct = false;
      this.justCreated = true;
      this.creationImagePreview = null;
      await this.recarregueEditor(false);
      this.markSaved();
      this.activeProductTab = 'info';
      this.scrollEditorContentToTop();
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível salvar o produto.');
    }
  }

  private validateCreation(): CreationErrorsV2 {
    const errors: CreationErrorsV2 = {};
    if (!this.editor) return errors;

    if (!this.editor.name?.trim()) {
      errors.name = 'Informe o nome do produto.';
    }

    if (this.creationPriceRequired && (this.editor.basePrice == null || this.editor.basePrice < 0)) {
      errors.basePrice = 'Informe o preço base.';
    }

    if (!this.editor.categoryId) {
      errors.categoryId = 'Escolha a categoria em que o produto vai aparecer.';
    }

    return errors;
  }

  /** Brinde só existe com preço zero — ver `sincronizeBrindeComPreco`. */
  get precoPermiteBrinde(): boolean {
    return (this.editor?.basePrice || 0) === 0;
  }

  /**
   * Antes o toggle "É brinde" simplesmente sumia quando o preço deixava de ser zero,
   * e a marcação ficava ligada por baixo. Agora ele fica visível e desabilitado, e a
   * marcação é desligada com aviso.
   */
  private sincronizeBrindeComPreco(): void {
    if (!this.editor) return;

    if (this.precoPermiteBrinde) {
      this.brindeDesligadoPeloPreco = false;
      return;
    }

    if (this.editor.ehBrinde) {
      this.editor.ehBrinde = false;
      this.brindeDesligadoPeloPreco = true;
    }
  }

  // ── Prévia de "visão do cliente" da aba Preço e promoção ──

  /**
   * Preço cheio, o que fica riscado na prévia.
   *
   * Não dá para usar `editor.basePrice`: o facade o calcula como
   * `companyPromo ?? globalPromo ?? companyBase ?? globalBase`, ou seja, quando
   * existe promoção o basePrice JÁ É o preço promocional. Quem guarda o valor
   * cheio é o raw, que é de onde o próprio cálculo de desconto parte.
   */
  get precoCheio(): number {
    if (!this.editor) return 0;
    const bruto = this.precoPorEmpresa
      ? (this.editor.raw?.precoNaEmpresa ?? this.editor.raw?.preco)
      : this.editor.raw?.preco;
    const valor = Number(bruto);
    return valor > 0 ? valor : (this.editor.basePrice || 0);
  }

  get temPromocaoValida(): boolean {
    if (!this.editor?.promotion?.exibirDescontos) return false;
    const novo = this.precoPromocional;
    return novo != null && novo > 0 && novo < this.precoCheio;
  }

  get precoPromocional(): number | null {
    if (!this.editor) return null;
    const valor = this.precoPorEmpresa
      ? this.editor.promotion.novoPrecoNaEmpresa
      : this.editor.promotion.novoPreco;
    return valor == null ? null : Number(valor);
  }

  get descontoPercentual(): number {
    const cheio = this.precoCheio;
    const novo = this.precoPromocional;
    if (!cheio || novo == null) return 0;
    return Math.max(0, Math.round((1 - novo / cheio) * 100));
  }

  get creationPriceRequired(): boolean {
    return !this.temModuloTabelaPrecos && this.editor?.type !== 'pizza';
  }

  get hasCreationErrors(): boolean {
    return Object.keys(this.creationErrors).length > 0;
  }

  private clearResolvedCreationErrors() {
    if (!this.hasCreationErrors) return;
    const current = this.validateCreation();
    const next: CreationErrorsV2 = {};
    (Object.keys(this.creationErrors) as Array<keyof CreationErrorsV2>).forEach(key => {
      if (current[key]) next[key] = this.creationErrors[key];
    });
    this.creationErrors = next;
  }

  private focusCreationField(field: keyof CreationErrorsV2) {
    setTimeout(() => {
      const host: HTMLElement | null = this.elementRef?.nativeElement;
      const wrapper = host?.querySelector<HTMLElement>(`[data-creation-field="${field}"]`);
      if (!wrapper) return;
      wrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
      const focusable = wrapper.querySelector<HTMLElement>('input, [tabindex], button');
      focusable?.focus();
    }, 0);
  }

  dismissCreatedBanner() {
    this.justCreated = false;
  }

  goToNextStepAfterCreation(tab: ProductEditorTabV2) {
    this.justCreated = false;
    this.setProductTab(tab);
  }

  getProductTabDisabledHint(tab: ProductEditorTabV2): string | null {
    if (!this.isProductTabDisabled(tab)) return null;
    if (tab === 'adicionais') return 'Salve o produto para configurar os adicionais.';
    if (tab === 'pricing') return 'Salve o produto para definir preço promocional e tabelas.';
    if (tab === 'fiscal') return 'Salve o produto para configurar fiscal e integrações.';
    return 'Salve o produto para definir a disponibilidade.';
  }

  onCreationImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];

    const validTypes = ['image/jpeg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      this.notificationService.showError('Formato inválido. Use JPG ou PNG.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      this.notificationService.showError('Imagem muito grande. Máximo 5MB.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.creationImagePreview = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }

  private uploadCreationImage(): Promise<void> {
    if (!this.creationImagePreview) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const blob = this.dataURItoBlob(this.creationImagePreview!);
      const formData = new FormData();
      formData.append('image', blob);

      this.httpClient.post<any>('/upload/imagens/crop/800', formData).subscribe(
        (response) => {
          if (!this.editor!.raw.imagens) {
            this.editor!.raw.imagens = [];
          }
          this.editor!.raw.imagens.push(response.data);
          this.facade.salveImagensProduto(this.empresa, this.editor!.raw).then(resolve).catch(reject);
        },
        (error) => {
          console.error('Erro ao fazer upload da imagem de criação:', error);
          resolve();
        }
      );
    });
  }

  private dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  onDisponibilidadeTipoChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.editor.availability.active = this.editor.availability.disponibilidadeTipo !== 2;
    this.onAvailabilityChange();
  }

  onAvailabilityChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.facade.apliqueDisponibilidade(this.editor.raw, this.editor.availability);

    this.scheduleSave('availability', async () => {
      try {
        await this.markSaving();
        await this.facade.salveDisponibilidade(this.empresa.catalogo, this.editor!.raw);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a disponibilidade.');
      }
    }, 500);
  }

  onClassificationChange(tagName?: string) {
    if (!this.editor || !this.podeEditarProdutos) return;

    this.facade.apliqueDestaque(this.editor.raw, this.editor.classification.destaque);
    if (tagName) {
      const alreadySelected = this.editor.classification.tags.includes(tagName);
      this.editor.classification.tags = alreadySelected
        ? this.editor.classification.tags.filter((tag) => tag !== tagName)
        : [...this.editor.classification.tags, tagName];
    }

    this.scheduleSave('classification', async () => {
      try {
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar a classificação.');
        if (!persisted) return;

        const tags = this.availableTags.filter((tag) => this.editor!.classification.tags.includes(tag.nome));
        await this.markSaving();
        await this.facade.salveProduto(this.editor!.raw);
        await this.facade.salveTags(this.empresa.catalogo, this.editor!.raw, tags);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a classificação.');
      }
    }, 500);
  }

  alterouNovoPreco() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.preco || 0;
    if (preco > 0 && this.editor.promotion.novoPreco != null) {
      this.editor.promotion.percentualDesconto = Number((100 - (this.editor.promotion.novoPreco / preco) * 100).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  alterouPercentualDesconto() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.preco || 0;
    if (preco > 0 && this.editor.promotion.percentualDesconto != null) {
      const desconto = preco * (this.editor.promotion.percentualDesconto / 100);
      this.editor.promotion.novoPreco = Number((preco - desconto).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  alterouNovoPrecoNaEmpresa() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.precoNaEmpresa || 0;
    if (preco > 0 && this.editor.promotion.novoPrecoNaEmpresa != null) {
      this.editor.promotion.percentualDescontoNaEmpresa = Number((100 - (this.editor.promotion.novoPrecoNaEmpresa / preco) * 100).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  alterouPercentualDescontoNaEmpresa() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.precoNaEmpresa || 0;
    if (preco > 0 && this.editor.promotion.percentualDescontoNaEmpresa != null) {
      const desconto = preco * (this.editor.promotion.percentualDescontoNaEmpresa / 100);
      this.editor.promotion.novoPrecoNaEmpresa = Number((preco - desconto).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  inserirDesconto() {
    if (!this.editor || !this.podeEditarPrecos) return;
    this.editor.promotion.exibirDescontos = true;
  }

  removerDesconto() {
    if (!this.editor || !this.podeEditarPrecos) return;
    this.editor.promotion.exibirDescontos = false;

    if (this.precoPorEmpresa) {
      delete this.editor.raw.percentualDescontoNaEmpresa;
      delete this.editor.raw.novoPrecoNaEmpresa;
      this.editor.promotion.novoPrecoNaEmpresa = null;
      this.editor.promotion.percentualDescontoNaEmpresa = null;
    } else {
      delete this.editor.raw.percentualDesconto;
      delete this.editor.raw.novoPreco;
      this.editor.promotion.novoPreco = null;
      this.editor.promotion.percentualDesconto = null;
    }

    this.editor.raw.destaque = false;
    this.editor.classification.destaque = false;
    this.schedulePromotionSave();
  }

  private syncPromotionToRaw() {
    if (!this.editor) return;

    if (this.precoPorEmpresa) {
      this.editor.raw.novoPrecoNaEmpresa = this.editor.promotion.novoPrecoNaEmpresa;
      this.editor.raw.percentualDescontoNaEmpresa = this.editor.promotion.percentualDescontoNaEmpresa;
    } else {
      this.editor.raw.novoPreco = this.editor.promotion.novoPreco;
      this.editor.raw.percentualDesconto = this.editor.promotion.percentualDesconto;
    }
  }

  private schedulePromotionSave() {
    this.scheduleSave('promotion', async () => {
      try {
        await this.markSaving();
        await this.facade.salveProduto(this.editor!.raw);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a promoção.');
      }
    }, 500);
  }

  alterouNovoPrecoTamanho(option: ChoiceOptionVM) {
    if (!option.raw || !this.podeEditarPrecoOpcoes) return;
    const preco = option.raw.preco || option.price || 0;
    if (preco > 0 && option.novoPreco != null) {
      option.percentualDesconto = Number((100 - (option.novoPreco / preco) * 100).toFixed(2));
    }
    this.syncPizzaSizeToRaw(option);
    this.schedulePromotionSave();
  }

  alterouPercentualDescontoTamanho(option: ChoiceOptionVM) {
    if (!option.raw || !this.podeEditarPrecoOpcoes) return;
    const preco = option.raw.preco || option.price || 0;
    if (preco > 0 && option.percentualDesconto != null) {
      const desconto = preco * (option.percentualDesconto / 100);
      option.novoPreco = Number((preco - desconto).toFixed(2));
    }
    this.syncPizzaSizeToRaw(option);
    this.schedulePromotionSave();
  }

  removerDescontoTamanho(option: ChoiceOptionVM) {
    if (!option.raw || !this.podeEditarPrecoOpcoes) return;
    delete option.raw.novoPreco;
    delete option.raw.percentualDesconto;
    option.raw.destaque = false;
    option.novoPreco = null;
    option.percentualDesconto = null;
    option.destaque = false;
    this.schedulePromotionSave();
  }

  private syncPizzaSizeToRaw(option: ChoiceOptionVM) {
    if (!option.raw) return;
    option.raw.codigoPdv = option.codigoPdv;
    option.raw.novoPreco = option.novoPreco;
    option.raw.percentualDesconto = option.percentualDesconto;
    option.raw.destaque = option.destaque;
  }

  async onFiscalSectionToggle() {
    this.sectionFiscalOpen = !this.sectionFiscalOpen;
    if (this.sectionFiscalOpen && !this.dadosFiscais && !this.fiscalLoading) {
      this.fiscalLoading = true;
      try {
        this.dadosFiscais = await this.facade.carregueDadosFiscais();
        await this.loadFiscalNcmOptions('', true);
        await this.loadFiscalCestOptions('', true);
      } finally {
        this.fiscalLoading = false;
      }
    }
  }

  onFiscalChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.syncFiscalToRaw();

    this.cancelPendingSave('fiscal');
    const fiscalValidationMessage = this.getFiscalValidationMessage();
    if (fiscalValidationMessage) {
      this.fiscalValidationMessage = fiscalValidationMessage;
      this.saveState = 'Erro ao salvar';
      this.saveStateMuted = false;
      return;
    }

    this.fiscalValidationMessage = '';
    this.scheduleSave('fiscal', async () => {
      try {
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar o fiscal.');
        if (!persisted) return;
        await this.markSaving();
        await this.facade.salveFiscal(this.editor!.raw);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar as configurações fiscais.');
      }
    }, 800);
  }

  onFiscalNcmChange(value: string) {
    if (!this.editor) return;
    const ncmAnterior = this.normalizeNcm(this.editor.fiscal.ncm);
    this.editor.fiscal.ncm = this.normalizeNcm(value);
    this.updateFiscalNcmSelecionado();
    if (ncmAnterior !== this.editor.fiscal.ncm && this.editor.fiscal.cest) {
      this.editor.fiscal.cest = '';
      this.updateFiscalCestSelecionado();
    }
    this.onFiscalChange();
    void this.loadFiscalNcmOptions(this.editor.fiscal.ncm, true);
    void this.loadFiscalCestOptions('', true);
  }

  onFiscalNcmFilterChange(value: string) {
    if (this.fiscalNcmSearchTimer) clearTimeout(this.fiscalNcmSearchTimer);
    this.fiscalNcmSearchTimer = setTimeout(() => {
      void this.loadFiscalNcmOptions(value || '', false);
    }, 250);
  }

  onFiscalCestChange(value: string) {
    if (!this.editor) return;
    this.editor.fiscal.cest = this.normalizeCest(value);
    this.updateFiscalCestSelecionado();
    this.onFiscalChange();
    void this.loadFiscalCestOptions(this.editor.fiscal.cest, true);
  }

  onFiscalCestFilterChange(value: string) {
    if (this.fiscalCestSearchTimer) clearTimeout(this.fiscalCestSearchTimer);
    this.fiscalCestSearchTimer = setTimeout(() => {
      void this.loadFiscalCestOptions(value || '', false);
    }, 250);
  }

  onFiscalDigitsFieldChange(field: 'cest' | 'gtin', value: string, maxLength: number) {
    if (!this.editor) return;
    this.editor.fiscal[field] = this.normalizeDigits(value, maxLength);
    this.onFiscalChange();
  }

  onFiscalUnitFieldChange(value: string) {
    if (!this.editor) return;
    this.editor.fiscal.unidade = this.normalizeAlphaNumeric(value, 3);
    this.onFiscalChange();
  }

  onFidelidadeChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.editor.raw.pontosGanhos = this.editor.fidelidade.pontosGanhos;
    this.editor.raw.cashback = this.editor.fidelidade.cashback;

    this.scheduleSave('fidelidade', async () => {
      try {
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar a fidelidade.');
        if (!persisted) return;
        await this.markSaving();
        await this.facade.salvePontosFidelidade(this.editor!.raw);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a pontuação fidelidade.');
      }
    }, 800);
  }

  private syncFiscalToRaw() {
    if (!this.editor) return;
    if (!this.editor.raw.configuracaoFiscal) {
      this.editor.raw.configuracaoFiscal = {};
    }
    const config = this.editor.raw.configuracaoFiscal;
    const fiscal = this.editor.fiscal;
    config.origem = fiscal.origem;
    config.cest = fiscal.cest;
    config.ncm = fiscal.ncm;
    config.gtin = fiscal.gtin;
    config.unidade = fiscal.unidade;
    config.tipoCalculoIPI = fiscal.tipoCalculoIPI;
    config.aliquotaIPI = fiscal.aliquotaIPI;
    config.valorPorUnidadeIPI = fiscal.valorPorUnidadeIPI;
    config.tipoDeTributacaoIPI = fiscal.tipoDeTributacaoIPI;
    config.seloDeControleIPI = fiscal.seloDeControleIPI;
    config.producaoPropria = fiscal.producaoPropria;
    config.ipiCompoeBaseCalculoICMS = fiscal.ipiCompoeBaseCalculoICMS;
    config.aliquotaAtributosAproximados = fiscal.aliquotaAtributosAproximados;
    config.informacoesAdicionais = fiscal.informacoesAdicionais;
  }

  private getFiscalValidationMessage(): string | null {
    if (!this.editor?.fiscal?.origem?.id) {
      return 'Selecione a origem para salvar os dados fiscais.';
    }

    const ncm = this.normalizeNcm(this.editor?.fiscal?.ncm);
    if (!/^\d{8}$/.test(ncm)) {
      return 'Informe o NCM com exatamente 8 digitos numericos.';
    }

    const ncmEncontrado = this.findFiscalNcmOption(ncm);
    if (!ncmEncontrado || this.isFiscalNcmPlaceholder(ncmEncontrado)) {
      return 'Selecione um NCM valido da base local.';
    }

    const cest = this.normalizeCest(this.editor?.fiscal?.cest);
    if (cest && !/^\d{7}$/.test(cest)) {
      return 'Informe o CEST com exatamente 7 digitos numericos.';
    }

    if (cest) {
      const cestEncontrado = this.findFiscalCestOption(cest);
      if (!cestEncontrado || this.isFiscalCestPlaceholder(cestEncontrado)) {
        return 'Selecione um CEST valido para o NCM informado.';
      }
    }

    const gtin = this.normalizeDigits(this.editor?.fiscal?.gtin, 14);
    if (gtin && !/^(\d{8}|\d{12}|\d{13}|\d{14})$/.test(gtin)) {
      return 'Informe o GTIN/EAN com 8, 12, 13 ou 14 digitos numericos.';
    }

    const unidade = this.normalizeAlphaNumeric(this.editor?.fiscal?.unidade, 3);
    if (unidade && !/^[A-Z0-9]{1,3}$/.test(unidade)) {
      return 'Informe a unidade fiscal com ate 3 caracteres alfanumericos.';
    }

    if (!this.isValidNumberRange(this.editor?.fiscal?.aliquotaIPI, 0, 100)) {
      return 'Informe a aliquota IPI com um valor entre 0 e 100.';
    }

    if (!this.isValidNumberRange(this.editor?.fiscal?.valorPorUnidadeIPI, 0)) {
      return 'Informe o valor por unidade IPI com um numero maior ou igual a zero.';
    }

    if (!this.isValidNumberRange(this.editor?.fiscal?.aliquotaAtributosAproximados, 0, 100)) {
      return 'Informe a aliquota de tributos aproximados com um valor entre 0 e 100.';
    }

    return null;
  }

  private normalizeNcm(value: any): string {
    return this.normalizeFiscalCode(value, 8);
  }

  private normalizeCest(value: any): string {
    return this.normalizeFiscalCode(value, 7);
  }

  private normalizeFiscalCode(value: any, length: number): string {
    const digits = String(value ?? '').replace(/\D/g, '');
    if (!digits) {
      return '';
    }

    return digits.length < length ? digits.padStart(length, '0') : digits;
  }

  private async loadFiscalNcmOptions(query: string = '', includeSelected: boolean = true) {
    this.fiscalNcmLoading = true;

    try {
      const codigoSelecionado = this.normalizeNcm(this.editor?.fiscal?.ncm);
      const codigoBusca = this.normalizeDigits(query, 8);
      const textoBusca = codigoBusca ? '' : String(query || '').trim();
      const codigoSelecionadoParaLista = includeSelected ? codigoSelecionado : '';
      const [opcoes, selecionado] = await Promise.all([
        this.facade.busqueNcms(textoBusca, codigoBusca, 80),
        includeSelected && codigoSelecionado ? this.loadFiscalNcmByCode(codigoSelecionado) : Promise.resolve(null)
      ]);

      this.fiscalNcmOptions = this.mergeFiscalNcmOptions(opcoes || [], selecionado, codigoSelecionadoParaLista);
      this.updateFiscalNcmSelecionado();
    } catch (error) {
      this.fiscalNcmOptions = this.mergeFiscalNcmOptions([], null, includeSelected ? this.normalizeNcm(this.editor?.fiscal?.ncm) : '');
      this.updateFiscalNcmSelecionado();
    } finally {
      this.fiscalNcmLoading = false;
    }
  }

  private async loadFiscalNcmByCode(codigo: string): Promise<ProductFiscalNcmOptionVM | null> {
    const normalizedCode = this.normalizeNcm(codigo);
    if (!normalizedCode) {
      return null;
    }

    const itens = await this.facade.busqueNcms('', normalizedCode, 5);
    return (itens || []).find((item) => item?.codigo === normalizedCode) || (itens && itens.length > 0 ? itens[0] : null);
  }

  private mergeFiscalNcmOptions(
    opcoes: ProductFiscalNcmOptionVM[],
    selecionado: ProductFiscalNcmOptionVM | null,
    codigoSelecionado: string
  ): ProductFiscalNcmOptionVM[] {
    const mapa = new Map<string, ProductFiscalNcmOptionVM>();

    (opcoes || []).forEach((opcao) => {
      if (!opcao?.codigo) return;
      mapa.set(opcao.codigo, this.decorateFiscalNcmOption(opcao));
    });

    if (selecionado?.codigo) {
      mapa.set(selecionado.codigo, this.decorateFiscalNcmOption(selecionado));
    }

    if (codigoSelecionado && !mapa.has(codigoSelecionado)) {
      mapa.set(codigoSelecionado, this.decorateFiscalNcmOption({
        codigo: codigoSelecionado,
        descricao: 'NCM atual nao encontrado na base local.',
        label: `${codigoSelecionado} - NCM atual nao encontrado na base local.`
      }));
    }

    return Array.from(mapa.values()).sort((a, b) => a.codigo.localeCompare(b.codigo));
  }

  private async loadFiscalCestOptions(query: string = '', includeSelected: boolean = true) {
    const ncmSelecionado = this.normalizeNcm(this.editor?.fiscal?.ncm);
    const codigoSelecionado = this.normalizeCest(this.editor?.fiscal?.cest);
    const codigoSelecionadoParaLista = includeSelected ? codigoSelecionado : '';

    if (!/^\d{8}$/.test(ncmSelecionado)) {
      this.fiscalCestOptions = this.mergeFiscalCestOptions([], null, codigoSelecionadoParaLista);
      this.updateFiscalCestSelecionado();
      return;
    }

    this.fiscalCestLoading = true;

    try {
      const codigoBusca = this.normalizeDigits(query, 7);
      const textoBusca = codigoBusca ? '' : String(query || '').trim();
      const [opcoes, selecionado] = await Promise.all([
        this.facade.busqueCests(ncmSelecionado, textoBusca, codigoBusca, 80),
        includeSelected && codigoSelecionado ? this.loadFiscalCestByCode(ncmSelecionado, codigoSelecionado) : Promise.resolve(null)
      ]);

      this.fiscalCestOptions = this.mergeFiscalCestOptions(opcoes || [], selecionado, codigoSelecionadoParaLista);
      this.updateFiscalCestSelecionado();
    } catch (error) {
      this.fiscalCestOptions = this.mergeFiscalCestOptions([], null, codigoSelecionadoParaLista);
      this.updateFiscalCestSelecionado();
    } finally {
      this.fiscalCestLoading = false;
    }
  }

  private async loadFiscalCestByCode(ncm: string, codigo: string): Promise<ProductFiscalCestOptionVM | null> {
    const normalizedNcm = this.normalizeNcm(ncm);
    const normalizedCode = this.normalizeCest(codigo);
    if (!normalizedNcm || !normalizedCode) {
      return null;
    }

    const itens = await this.facade.busqueCests(normalizedNcm, '', normalizedCode, 5);
    return (itens || []).find((item) => item?.codigo === normalizedCode) || (itens && itens.length > 0 ? itens[0] : null);
  }

  private mergeFiscalCestOptions(
    opcoes: ProductFiscalCestOptionVM[],
    selecionado: ProductFiscalCestOptionVM | null,
    codigoSelecionado: string
  ): ProductFiscalCestOptionVM[] {
    const mapa = new Map<string, ProductFiscalCestOptionVM>();

    (opcoes || []).forEach((opcao) => {
      if (!opcao?.codigo) return;
      mapa.set(opcao.codigo, this.decorateFiscalCestOption(opcao));
    });

    if (selecionado?.codigo) {
      mapa.set(selecionado.codigo, this.decorateFiscalCestOption(selecionado));
    }

    if (codigoSelecionado && !mapa.has(codigoSelecionado)) {
      mapa.set(codigoSelecionado, this.decorateFiscalCestOption({
        codigo: codigoSelecionado,
        descricao: 'CEST atual nao encontrado para o NCM informado.',
        label: `${this.formatCestCode(codigoSelecionado)} - CEST atual nao encontrado para o NCM informado.`
      }));
    }

    return Array.from(mapa.values()).sort((a, b) => a.codigo.localeCompare(b.codigo));
  }

  private findFiscalNcmOption(codigo: string): ProductFiscalNcmOptionVM | null {
    const normalizedCode = this.normalizeNcm(codigo);
    if (!normalizedCode) {
      return null;
    }

    return this.fiscalNcmOptions.find((item) => item.codigo === normalizedCode) || null;
  }

  private updateFiscalNcmSelecionado() {
    this.fiscalNcmSelecionado = this.findFiscalNcmOption(this.editor?.fiscal?.ncm || '');
  }

  private findFiscalCestOption(codigo: string): ProductFiscalCestOptionVM | null {
    const normalizedCode = this.normalizeCest(codigo);
    if (!normalizedCode) {
      return null;
    }

    return this.fiscalCestOptions.find((item) => item.codigo === normalizedCode) || null;
  }

  private updateFiscalCestSelecionado() {
    this.fiscalCestSelecionado = this.findFiscalCestOption(this.editor?.fiscal?.cest || '');
  }

  private decorateFiscalNcmOption(opcao: ProductFiscalNcmOptionVM): ProductFiscalNcmOptionVM {
    const descricao = String(opcao?.descricao || '').trim();
    return {
      ...opcao,
      shortLabel: `${opcao.codigo} - ${this.buildFiscalNcmTailDescription(descricao)}`,
      tailDescription: this.buildFiscalNcmTailDescription(descricao)
    };
  }

  private decorateFiscalCestOption(opcao: ProductFiscalCestOptionVM): ProductFiscalCestOptionVM {
    const descricao = String(opcao?.descricao || '').trim();
    const codigoFormatado = this.formatCestCode(opcao?.codigoFormatado || opcao?.codigo || '');
    return {
      ...opcao,
      codigoFormatado,
      shortLabel: `${codigoFormatado || opcao.codigo} - ${this.buildFiscalNcmTailDescription(descricao, 90)}`,
      tailDescription: this.buildFiscalNcmTailDescription(descricao, 90)
    };
  }

  private isFiscalNcmPlaceholder(opcao: ProductFiscalNcmOptionVM | null): boolean {
    return String(opcao?.descricao || '').trim() === 'NCM atual nao encontrado na base local.';
  }

  private isFiscalCestPlaceholder(opcao: ProductFiscalCestOptionVM | null): boolean {
    return String(opcao?.descricao || '').trim() === 'CEST atual nao encontrado para o NCM informado.';
  }

  private buildFiscalNcmTailDescription(descricao: string, maxLength: number = 110): string {
    const texto = String(descricao || '').replace(/\s+/g, ' ').trim();
    if (!texto) {
      return '';
    }

    if (texto.length <= maxLength) {
      return texto;
    }

    const segmentos = texto.split(' / ').map((item) => item.trim()).filter(Boolean);
    if (segmentos.length > 1) {
      let resumo = segmentos[segmentos.length - 1];
      for (let index = segmentos.length - 2; index >= 0; index -= 1) {
        const candidato = `${segmentos[index]} / ${resumo}`;
        if (candidato.length > maxLength - 4) {
          break;
        }
        resumo = candidato;
      }

      if (resumo.length < texto.length) {
        return `... ${resumo}`;
      }
    }

    return `... ${texto.slice(-(maxLength - 4))}`;
  }

  private normalizeDigits(value: any, maxLength: number): string {
    return String(value ?? '').replace(/\D/g, '').slice(0, maxLength);
  }

  private formatCestCode(value: any): string {
    const codigo = this.normalizeCest(value);
    if (codigo.length !== 7) {
      return codigo;
    }

    return `${codigo.slice(0, 2)}.${codigo.slice(2, 5)}.${codigo.slice(5)}`;
  }

  private normalizeAlphaNumeric(value: any, maxLength: number): string {
    return String(value ?? '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, maxLength);
  }

  private isValidNumberRange(value: any, min: number, max?: number): boolean {
    if (value == null || value === '') {
      return true;
    }

    const numero = Number(value);
    if (!Number.isFinite(numero) || numero < min) {
      return false;
    }

    return max == null || numero <= max;
  }

  async useLibraryGroup(group: LibraryGroupVM, clonar: boolean) {
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('A biblioteca está bloqueada neste catálogo compartilhado.');
      return;
    }
    const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de usar a biblioteca.');
    if (!persisted) return;

    try {
      await this.markSaving();
      await this.facade.vinculeGrupoDaBiblioteca(this.empresa.catalogo, this.editor!.raw, group, clonar);
      await this.recarregueEditor();
      if (this.isGroupDetailSurface) {
        const newestGroup = [...(this.editor?.groups || [])].sort((a, b) => (b.order || 0) - (a.order || 0))[0] || null;
        this.groupDraft = newestGroup ? this.cloneGroup(newestGroup) : this.buildEmptyGroupDraft();
        this.editingGroupId = newestGroup?.id ?? null;

        if (this.embedded) {
          this.requestSurfaceChange('group-detail', newestGroup?.id ?? null, newestGroup ? 'edit' : 'create');
        }
      }
      this.markSaved();
      this.closeLibrary();
      this.notificationService.showSuccess(clonar ? 'Adicional duplicado da biblioteca.' : 'Adicional vinculado da biblioteca.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível usar o adicional da biblioteca.');
    }
  }

  async reorderGroups(event: CdkDragDrop<ChoiceGroupVM[]>) {
    if (!this.editor || event.previousIndex === event.currentIndex) return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A ordem dos adicionais está bloqueada neste catálogo compartilhado.');
      return;
    }

    moveItemInArray(this.editor.groups, event.previousIndex, event.currentIndex);
    this.editor.groups.forEach((grupo, index) => {
      grupo.order = index;
    });

    try {
      await this.markSaving();
      await this.facade.reordeneGrupos(this.empresa.catalogo, this.editor.raw, this.editor.groups);
      await this.recarregueEditor(false);
      this.markSaved();
      this.notificationService.showSuccess('Ordem dos adicionais atualizada.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível reordenar os adicionais.');
    }
  }

  openReorderSheet(): void {
    if (!this.editor || !this.podeEditarEstruturaAdicional) return;
    const seen = new Set<string | number>();
    this.reorderList = this.editor.groups.filter((g) => {
      if (g.kind === 'pizza-sizes') return false;
      if (seen.has(g.id)) return false;
      seen.add(g.id);
      return true;
    });
    this.reorderDirty = false;
    this.reorderSheetOpen = true;
  }

  closeReorderSheet(): void {
    if (this.reorderDirty) {
      this.reorderShaking = false;
      requestAnimationFrame(() => {
        this.reorderShaking = true;
        setTimeout(() => this.reorderShaking = false, 500);
      });
      this.reorderErrorMsg = 'Salve ou descarte as alterações antes de fechar.';
      this.notificationService.showError('Você tem alterações pendentes. Clique em "Aplicar" para salvar ou "Cancelar" para descartar.');
      return;
    }
    this.forceCloseReorderSheet();
  }

  forceCloseReorderSheet(): void {
    this.reorderSheetOpen = false;
    this.reorderList = [];
    this.reorderDirty = false;
    this.reorderShaking = false;
    this.reorderErrorMsg = '';
  }

  onReorderDrop(event: CdkDragDrop<ChoiceGroupVM[]>): void {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.reorderList, event.previousIndex, event.currentIndex);
    this.reorderDirty = true;
  }

  async applyReorder(): Promise<void> {
    if (!this.editor || !this.reorderDirty || this.reorderApplying) return;
    this.reorderApplying = true;

    this.reorderList.forEach((grupo, index) => {
      grupo.order = index;
    });

    try {
      await this.markSaving();
      await this.facade.reordeneGrupos(this.empresa.catalogo, this.editor.raw, this.reorderList);
      await this.recarregueEditor(false);
      this.markSaved();
      this.notificationService.showSuccess('Ordem dos adicionais atualizada.');
      this.reorderErrorMsg = '';
      this.forceCloseReorderSheet();
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível reordenar os adicionais.');
    } finally {
      this.reorderApplying = false;
    }
  }

  trackByGroup(index: number, group: ChoiceGroupVM) {
    return group.id || index;
  }

  trackByOption(index: number, option: ChoiceOptionVM) {
    return option.id || index;
  }

  isDenseGroup(group: ChoiceGroupVM | null | undefined): boolean {
    return !!group && (group.options?.length || 0) >= this.mobileDenseGroupThreshold;
  }

  shouldUseDenseGroupSummary(group: ChoiceGroupVM | null | undefined): boolean {
    return !this.embedded && this.isMobile && !!group;
  }

  getGroupActiveOptionCount(group: ChoiceGroupVM | null | undefined): number {
    return (group?.options || []).filter((option) => option.active !== false).length;
  }

  getGroupInactiveOptionCount(group: ChoiceGroupVM | null | undefined): number {
    return Math.max((group?.options?.length || 0) - this.getGroupActiveOptionCount(group), 0);
  }

  getGroupOptionPreview(group: ChoiceGroupVM): string {
    const names = (group.options || [])
      .filter((option) => option.active !== false)
      .map((option) => option.name)
      .filter((name) => !!name);

    if (!names.length) {
      return 'Sem opções configuradas';
    }

    return names.slice(0, 3).join(', ');
  }

  getGroupOptionNames(group: ChoiceGroupVM): string[] {
    return (group.options || [])
      .filter(o => o.active !== false && !!o.name)
      .map(o => o.name)
      .slice(0, 3);
  }

  getGroupOptionRemainingCount(group: ChoiceGroupVM): number {
    const count = (group.options || [])
      .filter((option) => option.active !== false)
      .filter((option) => !!option.name)
      .length;
    return Math.max(count - 3, 0);
  }

  getGroupAvailableOptionCount(group: ChoiceGroupVM | null | undefined): number {
    return (group?.options || [])
      .filter((option) => option.active !== false)
      .filter((option) => !!option.name)
      .length;
  }

  getGroupAvailableOptionLabel(group: ChoiceGroupVM | null | undefined): string {
    const total = this.getGroupAvailableOptionCount(group);
    return `${total} ${total === 1 ? 'disponível' : 'disponíveis'}`;
  }

  getGroupRuleSummary(group: ChoiceGroupVM | null | undefined): string {
    if (!group) return '';
    return this.formatSelectionRule(group.type, group.required, group.min, group.max);
  }

  openGroupDetail(
    group?: ChoiceGroupVM,
    groupDraftMode: ProductEditorGroupDraftModeV2 | null = 'edit',
    startWithLibrary = false,
    optionMode: ProductEditorOptionModeV2 = 'review'
  ) {
    if (group?.kind === 'adicional') {
      this.openGlobalAdditional(group, optionMode);
      return;
    }

    this.resetOptionBrowserState();
    this.optionMode = optionMode;
    this.requestSurfaceChange('group-detail', group?.id ?? null, group ? groupDraftMode : 'create', startWithLibrary, optionMode);
  }

  setOptionFilter(filter: 'all' | 'active' | 'inactive') {
    this.optionFilter = filter;
    this.persistOptionState();
  }

  setOptionMode(mode: ProductEditorOptionModeV2) {
    const previousMode = this.optionMode;
    this.optionMode = mode;
    if (previousMode === 'batch-price' && mode !== 'batch-price') {
      this.clearBatchSelection();
      this.closeBatchSheet();
    }
    if (mode !== 'review') {
      this.editSheetOpen = false;
      this.commitEditingOption();
    }
    if (previousMode !== 'batch-price' && mode === 'batch-price') {
      this.preselectFilteredBatchOptions();
    }
    this.persistOptionState();
    this.syncOptionModeContext();
  }

  setOptionSearch(value: string) {
    this.optionSearch = value;
    this.persistOptionState();
  }

  setOptionSort(sort: ProductEditorOptionSortV2) {
    this.optionSort = sort;
    this.persistOptionState();
  }

  addOptionFromFocusedGroup() {
    if (!this.focusedGroup) return;
    this.resetOptionBrowserState();
    void this.addOption(this.focusedGroup);
  }

  isBatchOptionSelected(option: ChoiceOptionVM): boolean {
    return !!this.batchSelection[this.getOptionRuntimeKey(option)];
  }

  toggleBatchOption(option: ChoiceOptionVM, checked?: boolean) {
    const key = this.getOptionRuntimeKey(option);
    const nextValue = typeof checked === 'boolean' ? checked : !this.batchSelection[key];

    if (nextValue) {
      this.batchSelection[key] = true;
      return;
    }

    delete this.batchSelection[key];
  }

  selectAllFilteredBatchOptions() {
    this.filteredFocusedGroupOptions.forEach((option) => {
      this.batchSelection[this.getOptionRuntimeKey(option)] = true;
    });
  }

  clearBatchSelection() {
    this.batchSelection = {};
  }

  applyBatchPresetPrice(price: number) {
    this.batchPriceInput = this.formatMoneyValue(price);
    this.applyBatchPrice(price);
  }

  applyBatchInputPrice() {
    this.applyBatchPrice(this.parseOptionMoney(this.batchPriceInput));
  }

  async applyBatchAvailability(active: boolean) {
    const group = this.focusedGroup;
    if (!group) return;
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    if (!this.batchSelectedCount) {
      this.notificationService.showError('Selecione pelo menos uma opção.');
      return;
    }

    const total = this.batchSelectedCount;
    const nomeContagem = total === 1 ? '1 opção' : `${total} opções`;
    const sujeito = total === 1 ? 'A opção selecionada' : 'As opções selecionadas';
    const ok = await this.confirmacao.confirme(
      active ? `Ativar ${nomeContagem}?` : `Desativar ${nomeContagem}?`,
      active
        ? `${sujeito} volta${total === 1 ? '' : 'm'} a aparecer para o cliente.`
        : `${sujeito} deixa${total === 1 ? '' : 'm'} de aparecer para o cliente.`,
      active ? 'Ativar' : 'Desativar',
      active ? 'primaria' : 'perigo'
    );
    if (!ok) return;

    (group.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        option.active = active;
        this.syncOptionToRaw(group, option);
      });

    this.scheduleGroupSave(group);
    this.notificationService.showSuccess(active ? 'Opções ativadas em lote.' : 'Opções desativadas em lote.');
  }

  setFilteredOptionsAvailability(active: boolean) {
    const group = this.focusedGroup;
    if (!group) return;
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    this.filteredFocusedGroupOptions.forEach((option) => {
      option.active = active;
      this.syncOptionToRaw(group, option);
    });

    this.scheduleGroupSave(group);
    this.notificationService.showSuccess(active ? 'Opções ativadas.' : 'Opções desativadas.');
  }

  get modeThemeClass(): string {
    switch (this.optionMode) {
      case 'activation': return 'is-mode-onoff';
      case 'review': return 'is-mode-editar';
      case 'batch-price': return 'is-mode-lote';
      default: return '';
    }
  }

  get groupActiveCount(): number {
    return this.focusedGroup ? this.getGroupActiveOptionCount(this.focusedGroup) : 0;
  }

  get groupTotalCount(): number {
    return this.focusedGroup?.options?.length || 0;
  }

  isFixedGroup(group: ChoiceGroupVM | null | undefined): boolean {
    return !!group && group.kind === 'pizza-sizes';
  }

  canEditGroupStructure(group: ChoiceGroupVM | null | undefined): boolean {
    return !this.isFixedGroup(group) && this.podeEditarEstruturaAdicional;
  }

  // ── Adicional editor integration ──

  getActiveFocusGroupId(): number | string | null {
    return this.embedded ? this.focusGroupId : this.getContextFocusGroupId();
  }

  getActiveGroupDraftMode(): string | null {
    return this.embedded ? this.groupDraftMode : this.getContextGroupDraftMode();
  }

  async onAdicionalSaved(grupo: ChoiceGroupVM): Promise<void> {
    await this.recarregueEditor();
    this.markSaved();

    const resolvedGroupId = grupo?.id ?? this.getActiveFocusGroupId();
    const savedGroup = (this.editor?.groups || []).find((item) => String(item.id) === String(resolvedGroupId));
    if (savedGroup?.kind === 'adicional') {
      this.openGlobalAdditional(savedGroup);
      return;
    }

    this.requestSurfaceChange('overview');
  }

  async onLibraryGroupsLinked(count: number): Promise<void> {
    this.libraryOpen = false;
    await this.recarregueEditor();
    this.activeProductTab = 'adicionais';
    this.requestSurfaceChange('overview');
    this.markSaved();
    this.notificationService.showSuccess(`${count} ${count === 1 ? 'adicional vinculado' : 'adicionais vinculados'} ao produto.`);
  }

  setProductTab(tab: ProductEditorTabV2): void {
    if (this.isProductTabDisabled(tab)) return;
    this.activeProductTab = tab;
    this.scrollEditorContentToTop();
  }

  isProductTabDisabled(tab: ProductEditorTabV2): boolean {
    return this.isNewProduct
      && (tab === 'adicionais' || tab === 'availability' || tab === 'pricing' || tab === 'fiscal');
  }

  /**
   * Aba "Fiscal e integrações" só existe se algum dos módulos dela estiver ligado —
   * antes esses cartões ficavam empilhados no fim da aba Informações (B1).
   */
  get temAbaFiscal(): boolean {
    return this.temModuloFiscal || this.temModuloComissionamento || this.pontuarFidelidade || this.temModuloEstoque;
  }

  // Sai do editor: grava o pendente e leva o caminho de volta, para o operador
  // voltar ao mesmo produto e à mesma aba em vez de cair na lista.
  async openAdditionalCatalog(): Promise<void> {
    await this.flushPendingSaves();
    await this.router.navigate(['/admin/adicionais-v2'], {
      queryParams: {
        voltarProduto: this.editor?.id || null,
        voltarAba: this.editor?.id ? 'adicionais' : null
      }
    });
  }

  openGlobalAdditional(group: ChoiceGroupVM, optionMode: ProductEditorOptionModeV2 = 'review', event?: Event): void {
    event?.stopPropagation();
    if (!group?.id || group.kind !== 'adicional') return;

    void this.router.navigate(['/admin/adicionais-v2', group.id], {
      queryParams: {
        produto: this.editor?.id || null,
        voltarProduto: this.editor?.id || null,
        modoOpcoes: optionMode !== 'review' ? optionMode : null
      }
    });
  }

  private scrollEditorContentToTop(): void {
    setTimeout(() => {
      const canvas = this.elementRef.nativeElement.querySelector('.pv2-editor-canvas');
      const scrollParent = canvas?.closest('.pv2-editor-drawer') || canvas?.closest('.pv2-editor-page');
      if (scrollParent) {
        (scrollParent as HTMLElement).scrollTo({ top: 0, behavior: 'auto' });
      }
    }, 0);
  }

  async onAdicionalDeleted(grupo: ChoiceGroupVM): Promise<void> {
    this.libraryOpen = false;
    this.requestSurfaceChange('overview');
    await this.recarregueEditor();
    this.markSaved();
    this.notificationService.showSuccess('Adicional removido.');
  }

  onAdicionalActionBarStateChange(state: { creationPhase: 'config' | 'full'; saveFooterState: 'hidden' | 'dirty' | 'saving' | 'saved' }): void {
    this.adicionalActionBarState = state;
  }

  onAdicionalActionBarCancel(): void {
    this.adicionalEditorComponent?.onCancel();
  }

  onAdicionalActionBarSave(): void {
    void this.adicionalEditorComponent?.onSave();
  }

  onAdicionalActionBarSaveAndClose(): void {
    void this.adicionalEditorComponent?.onSaveAndClose();
  }

  onAdicionalRequestDelete(): void {
    this.adicionalEditorComponent?.requestDelete();
  }

  async onAdicionalDuplicated(): Promise<void> {
    await this.recarregueEditor();

    const newestGroup = [...(this.editor?.groups || [])]
      .filter((item) => item.kind === 'adicional')
      .sort((a, b) => (b.order || 0) - (a.order || 0))[0] || null;

    if (newestGroup) {
      this.openGlobalAdditional(newestGroup);
    } else {
      this.requestSurfaceChange('overview');
    }
    this.markSaved();
  }

  handleGroupPrimaryAction(group: ChoiceGroupVM, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    if (this.embedded || this.isFixedGroup(group) || !this.canEditGroupStructure(group)) {
      this.openGroupDetail(group);
      return;
    }

    void this.openGroupPanel(group);
  }

  onChipClickOnOff(option: ChoiceOptionVM): void {
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }
    option.active = !option.active;
    if (this.focusedGroup) {
      this.onOptionChanged(this.focusedGroup, option, 'availability');
    }
  }

  onChipClickEditar(option: ChoiceOptionVM): void {
    if (!this.podeEditarAlgumaOpcao) {
      this.notifySharedCatalogBlocked('A edição das opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    this.editingOptionId = option.id ?? option.name;
    this.editingOptionName = option.name;
    this.editingOptionDescription = option.description || '';
    this.editingOptionPrice = option.price;
    this.editingOptionActive = option.active !== false;
    this.editingOptionDisponivelParaDelivery = option.disponivelParaDelivery !== false;
    this.editingOptionDisponivelNaMesa = option.disponivelNaMesa !== false;
    this.editSheetOpen = true;
  }

  getEditingOption(): ChoiceOptionVM | null {
    if (!this.focusedGroup || this.editingOptionId == null) return null;
    return this.focusedGroup.options.find((o) => o.id === this.editingOptionId) || null;
  }

  closeEditSheet(): void {
    this.editSheetOpen = false;
    this.editingOptionId = null;
    this.editingOptionName = '';
    this.editingOptionDescription = '';
    this.editingOptionPrice = null;
    this.editingOptionActive = true;
    this.editingOptionDisponivelParaDelivery = true;
    this.editingOptionDisponivelNaMesa = true;
  }

  saveAndCloseEditSheet(): void {
    this.commitEditingOption();
    this.editSheetOpen = false;
  }

  deleteAndCloseEditSheet(): void {
    if (!this.focusedGroup) return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A exclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    const option = this.focusedGroup.options.find(
      (o) => (o.id ?? o.name) === this.editingOptionId
    );
    if (option) {
      this.removeOption(this.focusedGroup, option);
    }
    this.closeEditSheet();
  }

  onChipClickLote(option: ChoiceOptionVM): void {
    this.toggleBatchOption(option);
  }

  commitEditingOption(): void {
    if (this.editingOptionId == null || !this.focusedGroup) return;
    const option = this.focusedGroup.options.find(
      (o) => (o.id ?? o.name) === this.editingOptionId
    );
    if (option) {
      let changed = false;

      if (this.podeEditarEstruturaAdicional) {
        option.name = this.editingOptionName;
        option.description = this.editingOptionDescription;
        changed = true;
      }

      if (this.podeEditarPrecoOpcoes) {
        option.price = this.editingOptionPrice ?? 0;
        changed = true;
      }

      if (this.podeEditarDisponibilidadeOpcoes) {
        option.active = this.editingOptionActive;
        changed = true;
      }

      if (this.podeEditarExibicaoOpcoes) {
        option.disponivelParaDelivery = this.editingOptionDisponivelParaDelivery;
        option.disponivelNaMesa = this.editingOptionDisponivelNaMesa;
        changed = true;
      }

      if (changed) {
        this.syncOptionToRaw(this.focusedGroup, option);
        this.scheduleGroupSave(this.focusedGroup);
      }
    }
    this.editingOptionId = null;
    this.editingOptionName = '';
    this.editingOptionDescription = '';
    this.editingOptionPrice = null;
    this.editingOptionActive = true;
    this.editingOptionDisponivelParaDelivery = true;
    this.editingOptionDisponivelNaMesa = true;
  }

  isEditingOption(option: ChoiceOptionVM): boolean {
    return this.editingOptionId === (option.id ?? option.name);
  }

  openBatchSheet(): void {
    if (!this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }
    if (!this.batchSelectedCount) {
      this.notificationService.showError('Selecione pelo menos uma opção antes de alterar o preço.');
      return;
    }
    this.batchSheetOpen = true;
    this.batchAdjustMode = 'fixed';
    this.batchAdjustDirection = 'increase';
    this.batchAdjustValue = '';
  }

  closeBatchSheet(): void {
    this.batchSheetOpen = false;
    this.batchAdjustDirection = 'increase';
    this.batchAdjustValue = '';
  }

  setBatchAdjustMode(mode: BatchPriceAdjustMode): void {
    this.batchAdjustMode = mode;
    this.batchAdjustDirection = 'increase';
    this.batchAdjustValue = '';
  }

  setBatchAdjustDirection(direction: BatchPriceAdjustDirection): void {
    this.batchAdjustDirection = direction;
  }

  applyBatchAdjust(): void {
    const group = this.focusedGroup;
    if (!group || !this.batchSelectedCount) return;
    if (!this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }

    const rawValue = Math.abs(this.parseOptionMoney(this.batchAdjustValue));
    const signedValue = this.batchAdjustDirection === 'decrease' ? -rawValue : rawValue;

    (group.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        let newPrice: number;
        switch (this.batchAdjustMode) {
          case 'fixed':
            newPrice = rawValue;
            break;
          case 'increment':
            newPrice = Math.max(0, Number(option.price || 0) + signedValue);
            break;
          case 'percent':
            newPrice = Math.max(0, Number(option.price || 0) * (1 + signedValue / 100));
            newPrice = Math.round(newPrice * 100) / 100;
            break;
          default:
            newPrice = rawValue;
        }
        option.price = newPrice;
        this.syncOptionToRaw(group, option);
      });

    this.scheduleGroupSave(group);
    this.closeBatchSheet();
    this.notificationService.showSuccess('Preço ajustado em lote.');
  }

  private describeDraft(grupo: ChoiceGroupVM): string {
    const descricaoBase = this.formatSelectionRule(grupo.type, grupo.required, grupo.min, grupo.max);
    return grupo.multiplicaQuantidadeProduto === false
      ? `${descricaoBase} • Item complementar`
      : descricaoBase;
  }

  private formatSelectionRule(type: ChoiceGroupVM['type'], required: boolean, min: number, max: number): string {
    const normalizedMin = Math.max(0, Number(min || 0));
    const normalizedMax = Math.max(0, Number(max || 0));

    if (normalizedMin > 0 && normalizedMax > 0) {
      if (normalizedMin === normalizedMax) {
        return normalizedMax === 1 ? 'Selecione 1 opção' : `Selecione ${normalizedMax} opções`;
      }

      return `Selecione de ${normalizedMin} a ${normalizedMax} opções`;
    }

    if (normalizedMax > 0) {
      return normalizedMax === 1
        ? (required || type === 'single' ? 'Selecione 1 opção' : 'Selecione até 1 opção')
        : `Selecione até ${normalizedMax} opções`;
    }

    if (type === 'single') {
      return required ? 'Selecione 1 opção' : 'Selecione até 1 opção';
    }

    return required ? 'Selecione ao menos 1 opção' : 'Selecione opções';
  }

  getQuantityBehaviorLabel(multiplica?: boolean | null): string {
    return multiplica === false ? 'Item complementar' : 'Por unidade do produto';
  }

  getQuantityBehaviorExample(multiplica?: boolean | null): string {
    return multiplica === false
      ? '3 marmitas + 1 refrigerante = 1 refrigerante'
      : '3 marmitas + arroz branco = 3x arroz branco';
  }

  getQuantityBehaviorDescription(multiplica?: boolean | null): string {
    return multiplica === false
      ? 'Aparece uma vez no pedido, independente da quantidade. Ideal para sugerir itens que combinam.'
      : 'Cada unidade do produto inclui este adicional.';
  }

  private groupKey(grupo: ChoiceGroupVM): string {
    return `${grupo.kind}-${grupo.id}`;
  }

  private syncOptionToRaw(grupo: ChoiceGroupVM, option: ChoiceOptionVM, markUpdated = true) {
    if (!this.editor) return;

    option.raw = option.raw || {};
    option.raw.nome = option.name;
    option.raw.descricao = option.description || '';
    if (this.podeEditarExibicaoOpcoes || !option.raw.id) {
      option.raw.disponivelParaDelivery = option.disponivelParaDelivery !== false;
      option.raw.disponivelNaMesa = option.disponivelNaMesa !== false;
    }

    this.facade.apliqueEstadoOpcao(this.editor.raw, option.raw, {
      price: Number(option.price || 0),
      active: option.active
    });

    if (grupo.kind === 'pizza-sizes') {
      option.raw.preco = Number(option.price || 0);
      option.raw.disponivel = option.active;
      return;
    }

    if (option.raw.id) {
      delete option.raw.nova;
      if (markUpdated && !option.raw.removida) {
        option.raw.atualizar = true;
      }
      return;
    }

    option.raw.nova = true;
    delete option.raw.atualizar;
  }

  private cloneGroup(grupo: ChoiceGroupVM): ChoiceGroupVM {
    return JSON.parse(JSON.stringify(grupo));
  }

  private async prepareSharedGroup(grupo: ChoiceGroupVM): Promise<ChoiceGroupVM | null> {
    if (!this.editor) return null;

    // Duas ações distintas, não um sim/não: o OK/Cancelar do confirm nativo escondia isso.
    const escolha = await this.confirmacao.pergunte(
      'Adicional compartilhado',
      'Este adicional é usado em outros produtos. Editar em todos muda os outros também; duplicar cria uma cópia só deste produto.',
      [
        { texto: 'Duplicar só aqui', valor: 'duplicar', estilo: 'neutra' },
        { texto: 'Editar em todos', valor: 'todos', estilo: 'primaria' }
      ]
    );

    if (escolha === null) return null;
    if (escolha === 'todos') return grupo;

    const clone = this.cloneGroup(grupo);
    clone.id = null;
    clone.shared = false;
    clone.sharedCount = 0;
    clone.raw = null;
    clone.options = clone.options.map((option, index) => ({
      ...option,
      id: null,
      order: index,
      raw: {
        nome: option.name,
        valor: option.price,
        disponivel: option.active,
        nova: true
      }
    }));

    try {
      const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de duplicar o adicional.');
      if (!persisted) return null;

      await this.markSaving();
      await this.facade.salveGrupo(this.empresa.catalogo, this.editor.raw, clone,
        this.podeEditarExibicaoOpcoes);
      if (clone.raw) {
        this.editor.raw.camposAdicionais = this.editor.raw.camposAdicionais || [];
        this.editor.raw.camposAdicionais.push(clone.raw);
      }
      await this.facade.removaGrupo(this.editor.raw, this.empresa.catalogo, grupo);
      this.editor.raw.camposAdicionais = (this.editor.raw.camposAdicionais || []).filter((item: any) => item.id !== grupo.raw?.id);
      await this.recarregueEditor();
      this.markSaved();
      this.notificationService.showSuccess('Adicional compartilhado duplicado para edição local.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível duplicar o adicional compartilhado.');
      return null;
    }

    return this.editor.groups.find((current) => current.id === clone.id) || this.editor.groups.find((current) => current.name === clone.name) || null;
  }

  private scheduleGroupSave(grupo: ChoiceGroupVM) {
    if (!this.editor) return;

    this.scheduleSave(`grupo:${this.groupKey(grupo)}`, async () => {
      try {
        grupo.description = this.describeDraft(grupo);
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar as opções do adicional.');
        if (!persisted) return;

        await this.markSaving();
        await this.facade.salveGrupo(this.empresa.catalogo, this.editor!.raw, grupo,
          this.podeEditarExibicaoOpcoes);
        if (grupo.kind === 'adicional' && grupo.raw) {
          this.editor!.raw.camposAdicionais = this.editor!.raw.camposAdicionais || [];
          const exists = (this.editor!.raw.camposAdicionais || []).find((item: any) => item.id === grupo.raw.id);
          if (!exists) {
            this.editor!.raw.camposAdicionais.push(grupo.raw);
          }
        }
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar as opções do adicional.');
      }
    }, 800);
  }

  // ── Auto-save com debounce ──
  // O que está esperando o debounce fica num registro para que sair da tela dispare
  // o pendente em vez de descartá-lo (o clearTimeout do ngOnDestroy perdia a última edição).
  private pendingSaves = new Map<string, { timer: any; run: () => Promise<void> }>();
  private saveRunners = new Map<string, () => Promise<void>>();
  private currentSaveKey: string | null = null;

  private scheduleSave(key: string, run: () => Promise<void>, delay = 500) {
    // Marca quem está gravando para que um erro saiba qual gravação repetir.
    const executar = async () => {
      this.currentSaveKey = key;
      try {
        await run();
      } finally {
        this.currentSaveKey = null;
      }
    };

    this.saveRunners.set(key, executar);

    const pendente = this.pendingSaves.get(key);
    if (pendente) clearTimeout(pendente.timer);
    const timer = setTimeout(() => {
      this.pendingSaves.delete(key);
      void executar();
    }, delay);
    this.pendingSaves.set(key, { timer, run: executar });
  }

  private cancelPendingSave(key: string) {
    const pendente = this.pendingSaves.get(key);
    if (!pendente) return;
    clearTimeout(pendente.timer);
    this.pendingSaves.delete(key);
  }

  /** Executa agora o que estava esperando o debounce. Chamado ao sair da tela. */
  async flushPendingSaves(): Promise<void> {
    const pendentes = Array.from(this.pendingSaves.values());
    if (!pendentes.length) return;
    this.pendingSaves.clear();
    pendentes.forEach((pendente) => clearTimeout(pendente.timer));
    for (const pendente of pendentes) {
      await pendente.run();
    }
  }

  private async markSaving() {
    this.saveState = 'Salvando...';
    this.saveStateMuted = false;
  }

  private markSaved() {
    this.saveState = 'Salvo agora';
    this.saveStateMuted = true;
    this.saveError = null;
    this.productPersisted.emit();
  }

  // O erro de gravação fica na tela até ser resolvido ou dispensado — o texto do
  // header some rápido demais para um auto-save que falhou.
  private handleSaveError(error: any, fallbackMessage: string) {
    this.saveState = 'Erro ao salvar';
    this.saveStateMuted = false;
    this.saveError = {
      message: error?.message || fallbackMessage,
      key: this.currentSaveKey
    };
    // O aviso fica no topo do canvas; traz para a vista de quem está rolando lá embaixo.
    setTimeout(() => {
      const host: HTMLElement | null = this.elementRef?.nativeElement;
      host?.querySelector<HTMLElement>('.pv2-save-error')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  get canRetrySave(): boolean {
    return !!this.saveError?.key && this.saveRunners.has(this.saveError.key);
  }

  async retryFailedSave(): Promise<void> {
    const chave = this.saveError?.key;
    const gravar = chave ? this.saveRunners.get(chave) : null;
    if (!gravar || this.saveRetrying) return;

    this.saveRetrying = true;
    this.saveError = null;
    try {
      await gravar();
    } finally {
      this.saveRetrying = false;
    }
  }

  dismissSaveError(): void {
    this.saveError = null;
  }

  private async syncContextLoad(force = false) {
    const signature = this.getLoadSignature();
    if (!force && signature === this.lastLoadSignature) {
      return;
    }

    this.lastLoadSignature = signature;
    await this.carregueTela();
  }

  private getContextProductId(): number | null {
    if (this.embedded) {
      return this.productId != null ? Number(this.productId) : null;
    }

    const id = this.activatedRoute.snapshot.params.id;
    return id != null ? Number(id) : null;
  }

  private getContextProductType(): ProductTypeV2 {
    if (this.embedded) {
      return this.newProductType || 'normal';
    }

    return (this.activatedRoute.snapshot.queryParams.tipo || 'normal') as ProductTypeV2;
  }

  private shouldStartWithPreview(): boolean {
    return this.embedded ? this.startWithPreview : !!this.activatedRoute.snapshot.queryParams.preview;
  }

  private shouldStartWithLibrary(): boolean {
    return this.embedded
      ? this.startWithLibrary
      : !!(this.activatedRoute.snapshot.queryParams.drawerLibrary || this.activatedRoute.snapshot.queryParams.library);
  }

  private getContextOptionMode(): ProductEditorOptionModeV2 | null {
    if (this.embedded) {
      return this.requestedOptionMode;
    }

    return (this.activatedRoute.snapshot.queryParams.drawerOptionsMode
      || this.activatedRoute.snapshot.queryParams.optionsMode
      || null) as ProductEditorOptionModeV2 | null;
  }

  private getContextFocusGroupId(): number | string | null {
    if (this.embedded) {
      return this.focusGroupId;
    }

    const focusGroupId = this.activatedRoute.snapshot.queryParams.drawerGroup
      || this.activatedRoute.snapshot.queryParams.grupo;
    return focusGroupId != null ? focusGroupId : null;
  }

  private getContextGroupDraftMode(): ProductEditorGroupDraftModeV2 | null {
    if (this.embedded) {
      return this.groupDraftMode;
    }

    return (this.activatedRoute.snapshot.queryParams.drawerGroupMode
      || this.activatedRoute.snapshot.queryParams.groupMode
      || null) as ProductEditorGroupDraftModeV2 | null;
  }

  private getLoadSignature(): string {
    return JSON.stringify({
      embedded: this.embedded,
      productId: this.productId,
      newProductType: this.newProductType,
      startWithPreview: this.startWithPreview,
      startWithLibrary: this.startWithLibrary,
      surfaceMode: this.surfaceMode,
      focusGroupId: this.focusGroupId,
      groupDraftMode: this.groupDraftMode,
      requestedOptionMode: this.requestedOptionMode,
      crossSellProductId: this.crossSellProductId,
      routeProductId: this.embedded ? null : this.activatedRoute.snapshot.params.id || null,
      routeNewProductType: this.embedded ? null : this.activatedRoute.snapshot.queryParams.tipo || null,
      routePreview: this.embedded ? null : this.activatedRoute.snapshot.queryParams.preview || null,
      routeLibrary: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerLibrary || this.activatedRoute.snapshot.queryParams.library || null,
      routeFocusGroupId: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerGroup || this.activatedRoute.snapshot.queryParams.grupo || null,
      routeSurface: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerSurface || this.activatedRoute.snapshot.queryParams.surface || null,
      routeGroupDraftMode: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerGroupMode || this.activatedRoute.snapshot.queryParams.groupMode || null,
      routeOptionsMode: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerOptionsMode || this.activatedRoute.snapshot.queryParams.optionsMode || null
    });
  }

  private initializeExpandedGroups() {
    this.expandedGroups = {};
    const groups = this.editor?.groups || [];
    const focusGroupId = this.getContextFocusGroupId();

    if (this.embedded) {
      groups.forEach((grupo) => {
        this.expandedGroups[this.groupKey(grupo)] = false;
      });
      return;
    }

    if (focusGroupId != null) {
      const hasFocusedGroup = groups.some((grupo) => String(grupo.id) === String(focusGroupId));
      if (!hasFocusedGroup) {
        groups.forEach((grupo) => {
          this.expandedGroups[this.groupKey(grupo)] = true;
        });
        return;
      }

      groups.forEach((grupo) => {
        const isFocused = String(grupo.id) === String(focusGroupId);
        this.expandedGroups[this.groupKey(grupo)] = isFocused;
      });
      return;
    }

    groups.forEach((grupo) => {
      this.expandedGroups[this.groupKey(grupo)] = true;
    });
  }

  private initializeGroupDetailDraft() {
    if (!this.isGroupDetailSurface) {
      this.groupDraft = null;
      this.editingGroupId = null;
      this.optionBrowserContextKey = '';
      return;
    }

    const targetGroup = this.focusedGroup;
    const groupDraftMode = this.getContextGroupDraftMode();
    const requestedOptionMode = this.getContextOptionMode();
    const nextContextKey = targetGroup ? `group:${targetGroup.id}` : groupDraftMode === 'create' ? 'create' : '';

    if (nextContextKey !== this.optionBrowserContextKey) {
      this.resetOptionBrowserState();
      this.optionBrowserContextKey = nextContextKey;
    }

    this.loadPersistedOptionState(nextContextKey, requestedOptionMode);

    if (targetGroup) {
      this.groupDraft = this.cloneGroup(targetGroup);
      this.editingGroupId = targetGroup.id;
      this.groupPanelTitle = 'Editar adicional';
      return;
    }

    if (groupDraftMode === 'create') {
      this.groupDraft = this.buildEmptyGroupDraft();
      this.editingGroupId = null;
      this.groupPanelTitle = 'Novo adicional';
      return;
    }

    this.groupDraft = null;
    this.editingGroupId = null;
  }

  private buildEmptyGroupDraft(): ChoiceGroupVM {
    return {
      id: null,
      name: '',
      type: 'single',
      required: false,
      min: 0,
      max: 1,
      chargeType: 'soma',
      multiplicaQuantidadeProduto: true,
      shared: false,
      sharedCount: 0,
      order: this.editor?.groups.length || 0,
      kind: 'adicional',
      description: 'Selecione até 1 opção',
      options: []
    };
  }

  private syncBasicInfoToRaw() {
    if (!this.editor) return;

    this.editor.raw.nome = this.editor.name;
    this.editor.raw.descricao = this.editor.description;
    this.editor.raw.categoria = this.categorias.find((categoria) => categoria.id === this.editor?.categoryId) || null;
    this.facade.apliquePrecoEfetivo(this.editor.raw, this.editor.basePrice);

    this.editor.raw.codigoPdv = this.editor.codigoPdv;
    this.editor.raw.tipoDeVenda = this.editor.tipoDeVenda;
    this.editor.raw.incremento = this.editor.incremento;
    this.editor.raw.qtdeMinima = this.editor.qtdeMinima;
    this.editor.raw.qtdMaxima = this.editor.qtdMaxima;
    this.editor.raw.pesoMinimo = this.editor.pesoMinimo;
    this.editor.raw.pesoMaximo = this.editor.pesoMaximo;
    this.editor.raw.valorMinimoVenda = this.editor.valorMinimoVenda;
    this.editor.raw.unidadeMedida = this.editor.unidadeMedida;
    this.editor.raw.valorInicial = this.editor.valorInicial;
    this.editor.raw.ehBrinde = this.editor.ehBrinde;
    this.editor.raw.naoAceitaCupom = this.editor.naoAceitaCupom;
    this.editor.raw.sincronizarModelos = this.editor.sincronizarModelos;
  }

  private async ensureProductPersisted(errorMessage: string): Promise<boolean> {
    if (!this.editor) return false;

    if (this.editor.id || this.editor.raw?.id) {
      await this.syncResolvedProductState(false);
      return true;
    }

    this.syncBasicInfoToRaw();

    try {
      await this.markSaving();
      await this.facade.salveProduto(this.editor.raw);
      await this.syncResolvedProductState(true);
      this.isNewProduct = false;
      return true;
    } catch (error: any) {
      this.handleSaveError(error, errorMessage);
      return false;
    }
  }

  private async syncResolvedProductState(replaceUrl: boolean): Promise<void> {
    if (!this.editor?.raw?.id) return;

    const resolvedId = Number(this.editor.raw.id);
    const shouldEmitResolved = this.editor.id == null || Number(this.editor.id) !== resolvedId;
    this.editor.id = resolvedId;

    if (shouldEmitResolved) {
      this.productResolved.emit(resolvedId);
    }

    if (!this.embedded && replaceUrl) {
      await this.navigateToAdminEditor(resolvedId, this.getResolvedEditorQueryParams(), { replaceUrl: true });
    }
  }

  private getResolvedEditorQueryParams(): any {
    const queryParams = { ...this.activatedRoute.snapshot.queryParams };
    delete queryParams['tipo'];
    return queryParams;
  }

  private requestSurfaceChange(
    surfaceMode: ProductEditorSurfaceV2,
    focusGroupId: number | string | null = null,
    groupDraftMode: ProductEditorGroupDraftModeV2 | null = null,
    startWithLibrary = false,
    optionMode: ProductEditorOptionModeV2 | null = null
  ) {
    this.groupDraft = null;
    this.editingGroupId = null;

    if (this.embedded) {
      this.surfaceChangeRequested.emit({
        surfaceMode,
        focusGroupId,
        groupDraftMode,
        startWithLibrary,
        optionMode
      });
      return;
    }

    void this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        drawerSurface: surfaceMode !== 'overview' ? surfaceMode : null,
        surface: surfaceMode !== 'overview' ? surfaceMode : null,
        drawerGroup: focusGroupId != null ? focusGroupId : null,
        grupo: focusGroupId != null ? focusGroupId : null,
        drawerGroupMode: groupDraftMode || null,
        groupMode: groupDraftMode || null,
        drawerLibrary: startWithLibrary ? 1 : null,
        library: startWithLibrary ? 1 : null,
        drawerOptionsMode: optionMode || null,
        optionsMode: optionMode || null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  private syncOptionModeContext() {
    if (this.embedded) {
      this.surfaceChangeRequested.emit({
        surfaceMode: this.activeSurfaceMode,
        focusGroupId: this.getContextFocusGroupId(),
        groupDraftMode: this.getContextGroupDraftMode(),
        startWithLibrary: this.shouldStartWithLibrary(),
        optionMode: this.optionMode
      });
      return;
    }

    void this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        drawerOptionsMode: this.optionMode || null,
        optionsMode: this.optionMode || null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  private async promoteToDedicatedEditor(grupo?: ChoiceGroupVM, forceOverview = false) {
    if (!this.editor) return;

    const queryParams: any = {};

    if (grupo?.id != null) {
      queryParams.drawerGroup = grupo.id;
      queryParams.grupo = grupo.id;
    }

    if (forceOverview) {
      queryParams.drawerSurface = null;
      queryParams.surface = null;
      queryParams.drawerGroup = null;
      queryParams.grupo = null;
      queryParams.drawerGroupMode = null;
      queryParams.groupMode = null;
      queryParams.drawerLibrary = null;
      queryParams.library = null;
      queryParams.drawerOptionsMode = null;
      queryParams.optionsMode = null;
    } else if (this.activeSurfaceMode !== 'overview') {
      queryParams.drawerSurface = this.activeSurfaceMode;
      queryParams.surface = this.activeSurfaceMode;
    }

    if (!forceOverview && this.getContextGroupDraftMode()) {
      queryParams.drawerGroupMode = this.getContextGroupDraftMode();
      queryParams.groupMode = this.getContextGroupDraftMode();
    }

    if (!forceOverview && this.libraryOpen) {
      queryParams.drawerLibrary = 1;
      queryParams.library = 1;
    }

    if (!forceOverview && this.optionMode) {
      queryParams.drawerOptionsMode = this.optionMode;
      queryParams.optionsMode = this.optionMode;
    }

    if (this.editor.type && !this.editor.id) {
      queryParams.tipo = this.editor.type;
    }

    if (this.editor.id) {
      await this.navigateToAdminEditor(this.editor.id, queryParams);
      return;
    }

    await this.navigateToAdminNewProduct(queryParams);
  }

  private async navigateToAdminCatalog() {
    return this.navigateWithFeedback(
      ['/admin/produtos-v2'],
      {},
      'Não foi possível voltar para o catálogo de produtos.'
    );
  }

  private async navigateToAdminEditor(productId: number, queryParams: any = {}, extras: any = {}) {
    return this.navigateWithFeedback(
      [`/admin/produtos-v2/${productId}`],
      {
        ...extras,
        queryParams
      },
      'Não foi possível abrir o editor do produto.'
    );
  }

  private async navigateToAdminNewProduct(queryParams: any = {}, extras: any = {}) {
    return this.navigateWithFeedback(
      ['/admin/produtos-v2/novo'],
      {
        ...extras,
        queryParams
      },
      'Não foi possível abrir o cadastro do produto.'
    );
  }

  private async navigateWithFeedback(commands: any[], extras: any, errorMessage: string): Promise<boolean> {
    try {
      const navigated = await this.router.navigate(commands, extras);
      if (!navigated) {
        this.notificationService.showError(errorMessage);
      }
      return navigated;
    } catch (error: any) {
      this.notificationService.showError(error?.message || errorMessage);
      return false;
    }
  }

  private resetOptionBrowserState() {
    if (this.optionMode === 'batch-price') {
      this.clearBatchSelection();
    }
    this.optionMode = 'review';
    this.optionSearch = '';
    this.optionFilter = 'all';
    this.optionSort = 'name-asc';
    this.batchPriceInput = '';
  }

  private loadPersistedOptionState(contextKey: string, requestedMode: ProductEditorOptionModeV2 | null) {
    this.optionMode = this.groupOptionModes[contextKey] || requestedMode || 'review';
    this.optionSearch = this.groupOptionSearchState[contextKey] || '';
    this.optionFilter = this.groupOptionFilterState[contextKey] || 'all';
    this.optionSort = this.groupOptionSortState[contextKey] || 'name-asc';
    this.batchPriceInput = '';
    this.clearBatchSelection();
    if (this.optionMode === 'batch-price') {
      this.preselectFilteredBatchOptions();
    }
  }

  private persistOptionState() {
    if (!this.optionBrowserContextKey) return;

    this.groupOptionModes[this.optionBrowserContextKey] = this.optionMode;
    this.groupOptionSearchState[this.optionBrowserContextKey] = this.optionSearch;
    this.groupOptionFilterState[this.optionBrowserContextKey] = this.optionFilter;
    this.groupOptionSortState[this.optionBrowserContextKey] = this.optionSort;
  }

  private preselectFilteredBatchOptions() {
    this.filteredFocusedGroupOptions.forEach((option) => {
      this.batchSelection[this.getOptionRuntimeKey(option)] = true;
    });
  }

  private getOptionRuntimeKey(option: ChoiceOptionVM): string {
    const existing = this.optionRuntimeKeys.get(option);
    if (existing) return existing;

    const key = option.id != null ? `option:${option.id}` : `draft:${++this.optionRuntimeKeySequence}`;
    this.optionRuntimeKeys.set(option, key);
    return key;
  }

  private applyBatchPrice(price: number) {
    const group = this.focusedGroup;
    if (!group || !this.batchSelectedCount) return;
    if (!this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }

    (group.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        option.price = price;
        this.syncOptionToRaw(group, option);
      });

    this.scheduleGroupSave(group);
    this.notificationService.showSuccess('Preço aplicado em lote.');
  }

  private parseOptionMoney(value: string): number {
    const normalized = String(value || '0').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : 0;
  }

  private formatMoneyValue(value: number): string {
    return Number(value || 0).toFixed(2).replace('.', ',');
  }

  private notifySharedCatalogBlocked(message = this.mensagemBloqueioCatalogoRede): void {
    const detalhe = this.mensagemBloqueioCatalogoRede;
    this.notificationService.showError(message === detalhe ? message : `${message} ${detalhe}`);
  }
}
